import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  ElementRef,
  ViewChild,
  HostListener,
  DoCheck,
  Renderer2,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import {forkJoin, Observable, of, Subject, Subscription} from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  map,
  first,
  finalize,
  switchMap,
  catchError
} from "rxjs/operators";
import { DatePipe, DecimalPipe, formatDate } from "@angular/common";
import { NgbModal, ModalDismissReasons, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
const printJS = require("print-js");

// MODELOS
import {
  Params,
  IdentificationType,
  UserAssigns,
  IDocumentLine,
  PayTermsEnum,
  ISaleOrder,
  ISaleQuotation,
  IBusinessPartner,
  IPaymentMethod,
  IOverdueBalance,
  IPrinter,
  IDocument,
} from "./../../../models/index";
import {
  ReportType,
  BaseTypeLines,
  SOAndSQActions,
  ITEM_GROUP_NAME,
  KEY_CODE,
  PRINTERS_PER_REPORT,
  BoDocumentTypes,
} from "../../../enum/enum";
// RUTAS

// COMPONENTES

// SERVICIOS
import { ActivatedRoute, Router } from "@angular/router";
import {
  CompanyService,
  UserService,
  ItemService,
  BusinessPartnerService,
  DocumentService,
  TaxService,
  PermsService,
  AuthenticationService,
  ParamsService,
  ReportsService,
  AlertService,
  SalesManService,
  ExRateService,
  JsonDataService,
  StorageService,
  CommonService,
} from "../../../services/index";

// Electron renderer service
import { SOAndSQService } from "src/app/services/soand-sq.service";
import { app } from "electron";
import { constants } from "os";
import swal from "sweetalert2";
import { SLDocument } from "src/app/models/i-sl-document-model";
import {IUdf, UDFModel2} from "src/app/models/i-udf";
import { BPAutorizedContactsComponent } from "src/app/components/custom-modals/bpautorized-contacts/bpautorized-contacts.component";
import {IBusinessPartnerModel, IBussinesPartnertVerfiedModel, ISaleMan} from "../../../models/i-business-partner";
import {ItemModelSearch} from "../../../models/i-item";
import {ParamsSearch} from "../../../models/params";
import {SearchModalComponent} from "../../../components/shared/search-modal/search-modal.component";
import { ITypeaheadSettings } from "src/app/models/company";
import { ISaleCondition } from "src/app/models/i-sale-condition";
import { IDiscountType } from "src/app/models/i-discount-type";
// import { ConsoleReporter } from 'jasmine';

// PIPES

@Component({
  selector: "app-sale-order",
  templateUrl: "./sale-order.component.html",
  styleUrls: ["./sale-order.component.scss"],
  providers: [DecimalPipe, DatePipe],
})
export class SaleOrderComponent
  implements OnInit, OnDestroy, DoCheck, AfterViewInit {
  //VARBOX
  isDocumentSubmitted: boolean;
  previusAmount: number;
  isPriceEditable: boolean;
  eventManager: Subscription;
  uniqueInvCode: string;
  isSalesManSelected: boolean;
  documentType: string;
  isRequiredEmail: boolean;
  hasIdentification: boolean;
  isOnPrint: boolean;
  priceList: number;
  //subscriptions: Subscription;
  currentRequest: number;
  requestToAwait: number;
  $requestViewer: Subject<number>;
  InvalidCardName: boolean;
  returnedDocEntry: number;
  returnedDocNum: number;
  titleSaleOrder: string;
  overdueBalances: IOverdueBalance[];
  paymentMethods: IPaymentMethod[];
  saleConditions: ISaleCondition[];
  discountTypes: IDiscountType[];
  isEditingPrice: boolean;
  isCashCustomer: boolean;
  typeArrow: boolean; // Hace toggle al darle click
  saleDocumentModel: ISaleOrder;
  hasLines: boolean;
  //#region Cambios Jorge EMA Aromas
  whCode: string;
  whName: string;
  //#endregion
  currentUser: any; // variable para almacenar el usuario actual
  currentUserSubscription: Subscription; // suscripcion para obtener el usuario actual

  public model: any;
  @BlockUI() blockUI: NgBlockUI;

  soForm: FormGroup; // formulario para la orden de venta
  feForm: FormGroup;
  // totalForm: FormGroup; // formulario para el total de la orden de venta
  submitted = false; // variable para reconcer si se envio una peticion o no
  maxDiscuont: any;
  setCurr: string; // tipo de moneda escogida en simbolo
  currencyList: any[] = []; // lista de tipos de cambio
  allCurrencyList: any[] = []; // lista de todos los tipos de cambio existentes en la aplicacion
  itemsList: IDocumentLine[] = []; // lista de items
  itemsTypeaheadList: string[] = []; // lista de la concatenacion del Código con el nombre del item
  itemsCodeList: string[] = []; // lista de los Códigos de items
  itemsNameList: string[] = []; // lista de los nombres de items
  itemsStock: string[] = [];
  itemsInventory: string[] = [];
  PayTermsList: any[] = []; // lista de los terminos de pago
  PriceList: any[] = []; // lista de las listas de precio
  businessPartnersSelect: IBusinessPartnerModel =  null;// cliente seleccionado
  businessPartnerDefault: IBusinessPartnerModel =  null;// lista por defecto
  companiesList: any[] = []; // lista de las compannias
  slpTypeaheadList: ISaleMan[] = [];

  userAssignsList: UserAssigns[] = [];
  defaultSlpCode: number = -1; // para saber cual es el salesperson por default de cada persona

  conta: number; // variable contador para colocar un 'id' a la lista de items
  total: number; // variable para almacenar el total de la factura
  totalUSD: number;
  tax: number; // variable para almacenar el total de impuestos
  discount: number; // variable para almacenar el total de descuento
  documentLevelDiscount: number = 0; // descuento a nivel de documento (desde SAP)
  totalWithoutTax: number; // variable para almacenar el total sin impuesto
  DailyExRate: number;
  taxesList: any[] = []; // lista de los impuestos
  typeaheadSettings: ITypeaheadSettings;

  viewParamList: any[] = []; // llena la lista con los componentes parametrizados
  viewParamListHeader: any[] = []; // llena la lista con los componentes parametrizados
  viewParamListTotales: any[] = []; // llena la lista con los componentes parametrizados
  viewParamTitles: any[] = []; // llena la lista con los titulos de las paginas parametrizados

  closeResult: string; // variable para saber porque se cerro la modal
  modalReference: any; // instancia de la modal de terminal y sucursal

  WHAvailableItemList: any[] = []; // lista de los items disponibles por almacen
  indexAvaItem: number; // indice de la lista del item seleccionado para la disponibilidad
  itemCode: string; // variable para almacenar el Código del ite seleccionado para buscar la disponibilidad
  seriesList: any[] = []; // lista de las series de un item po almacen
  lastSO: number; // guarda el id de la ultima orden de venta generada, se usa para imprimir

  public expandedIndex: number; // variable para manejar el collapse de los items y reconocer sobre cual se va a trabajar

  btnVisibleBool: boolean; // activa y desactiva los botones de envio y nuevo
  isOnCreation: boolean;
  correctSO: boolean = false; //dice si el pago se realizo correctamente
  // --------Campos Parametrizados cabezera
  lbCardCode: Params = new Params(); // etiqueta para CardCode
  txtCardCode: Params = new Params(); // campo para CardCode
  lbCardName: Params = new Params(); // etiqueta para CardName
  txtCardName: Params = new Params(); // campo para CardName
  lbCurrency: Params = new Params(); // etiqueta para Moneda
  txtCurrency: Params = new Params(); // campo para Moneda
  txtPayTerms: Params = new Params(); // campo para Terminos de pagos
  lbPayTerms: Params = new Params(); // etiqueta para Terminos de pagos
  txtPriceList: Params = new Params(); // campo para Listas de precios
  lbPriceList: Params = new Params(); // etiqueta para Listas de precios
  txtComments: Params = new Params(); // campo para el comentario
  lbComments: Params = new Params(); // etiqueta para el comentario
  lbSLP: Params = new Params(); // etiqueta para el vendedor
  txtSLP: Params = new Params(); // campo para el vendedor
  DEFAULT_BUSINESS_PARTNER: string;
  onSubmitButtonPrefix: string;
  // -----------------------------
  // -------- Campos para metrizables de totales
  lbTotalExe: Params = new Params(); // etiqueta para Total sin impuestos
  txtTotalExe: Params = new Params(); // campo para Total sin impuestos
  lbDiscount: Params = new Params(); // etiqueta para descuentos
  txtDiscount: Params = new Params(); // campo para descuentos
  lbTaxes: Params = new Params(); // etiqueta para Impuestos
  txtTaxes: Params = new Params(); // campo para Impuestos
  lbTotal: Params = new Params(); // etiqueta para Total
  txtTotal: Params = new Params(); // campo para Total
  // -----------------------------
  TotalCol: FormControl = new FormControl();
  TotalUSD: FormControl = new FormControl();
  Cant: FormControl = new FormControl();
  ItemInfo: FormControl = new FormControl();
  title: string; // titulo de la vista
  defaultGroupNum: any;
  defaultListNum: any;
  identificationTypeList: any[] = [];
  provinceList: any[] = []; // provincias
  cantonList: any[] = []; // lista de cantones
  districtList: any[] = []; // lista de distritos
  neighborhoodList: any[] = []; // lista de barrios

  provinceId: string; // identificador de la provincia
  cantonId: string; // identificador del canton
  districtId: string; // identificador del distrito
  neighborhoodId: string; // identificador del barrio
  @ViewChild("name") nameField: ElementRef;
  @ViewChild("cardNameInput") cardNameInput: ElementRef;
  // true cuando el cajero digito manualmente el nombre del cliente (socios de Contado).
  // Impide que una respuesta asincrona tardia del socio por defecto sobrescriba lo digitado.
  isCardNameTypedByUser: boolean = false;
  permisos: boolean = true;

  pesoBolsa: number = 0.02;
  priceEditable: boolean = false;
  maxWeightTo0: number = 0.01;

  autForm: FormGroup;
  canAuthorize: boolean;
  typeArrow2: boolean;

  MapWidth: any;
  tableLength: number;

  isOnSubmit: boolean = false;

  baseLines: IDocumentLine[];
  UdfsInDocument: UDFModel2[];
  dateTimeExitUI = "";

  isOrderFromLink: boolean;

  BpDocuemntPendingPay: boolean; //Realizar orden o enviar orden a autorizacion
  isPermAutorizeSale: boolean; //Permiso usuarios autorizar ventas a clientes con documentos vencidos
  isAutBtn: boolean = false; //Actualizar orden de envio aut
  showBtnBPContacs: boolean;
  IndexMaxUpdate: number;
  IndexMinDocument: number;
  DOC_ENTRY = -1;

  @HostListener("window:keyup", ["$event"])
  keyEvent(event: KeyboardEvent) {
    if (
      event.ctrlKey &&
      !event.altKey &&
      !event.shiftKey &&
      event.keyCode === KEY_CODE.Enter
    ) {
    
      this.onSubmit();
    }
    if (
      event.ctrlKey &&
      !event.altKey &&
      !event.shiftKey &&
      event.keyCode === KEY_CODE.F6
    ) {
      this.redirectToQuotation();
    }
    if (
      event.ctrlKey &&
      !event.altKey &&
      !event.shiftKey &&
      event.keyCode === KEY_CODE.F8
    ) {
      this.redirectToSOandSQ();
    }
  }

  constructor(
    private storageService: StorageService,
    private renderer: Renderer2,
    private commonService: CommonService,
    private fb: FormBuilder,
    private itemService: ItemService,
    private bpService: BusinessPartnerService,
    private decimalPipe: DecimalPipe,
    private documentService: DocumentService,
    private sPerm: PermsService,
    private companyService: CompanyService,
    private taxService: TaxService,
    private uService: UserService,
    private authenticationService: AuthenticationService,
    private modalService: NgbModal,
    //private _electronService: ElectronService,
    private paramsService: ParamsService,
    private reportsService: ReportsService,
    private router: Router,
    private exrate: ExRateService,
    private alertService: AlertService,
    private smService: SalesManService,
    private jsonDataService: JsonDataService,
    private storage: StorageService,
    private soAdnSQService: SOAndSQService,
    private el: ElementRef,
    private datePipe: DatePipe,
    private route: ActivatedRoute
  ) {
    this.$requestViewer = new Subject();
    this.currentUserSubscription =
      this.authenticationService.currentUser.subscribe((user) => {
        this.currentUser = user;
      });
    this.expandedIndex = -1;
  }

  ngDoCheck(): void {
    const parent: HTMLElement = document.getElementById(
      "scrollable-dropdown-menu"
    );
    if (parent && parent.children.length > 0) {
      const child = parent.children[1];
      if (child) {
        this.renderer.setStyle(child, "max-height", " 400px");
        this.renderer.setStyle(child, "overflow-y", "auto");
      }
    }
  }

  expandRow(index: number): void {
    this.expandedIndex = index === this.expandedIndex ? -1 : index;
  }

  /**
   * Method to load initial data
   * @constructor
   */
  LoadInitialData() {
    this.showBtnBPContacs = false;
    this.lastSO = 0;
    this.isDocumentSubmitted = false;

    this.IndexMinDocument = 0 ;
    this.IndexMaxUpdate = 0;
    this.isRequiredEmail = false;

    //Customer
    this.businessPartnersSelect = null;
    this.businessPartnersSelect = null;

    //Items
    this.itemsTypeaheadList.length = 0;
    this.itemsList = [];
    this.itemsCodeList.length = 0;
    this.itemsNameList.length = 0;
    this.itemsStock = [];
    this.itemsInventory = [];
    this.Cant.setValue(1);


    //User
    this.userAssignsList = [];

    //Vendedores
    this.slpTypeaheadList = [];

    //Companias
    this.companiesList = [];

    //Currency
    this.currencyList = [];
    this.allCurrencyList = [];

    //PayTerms
    this.PayTermsList = [];

    //GetOrder
    this.conta = 0;
    this.total = 0;
    //Taxes
    this.taxesList = [];
    this.ItemInfo.setValue("");



    this.UdfsInDocument = [];
    this.UdfsInDocument = this.GetDocumentUDFs();
    this.isSalesManSelected = true;
    this.hasIdentification = false;
    this.isOnPrint = false;
    this.currentRequest = 0;
    this.requestToAwait = 2;
    this.InvalidCardName = false;
    this.overdueBalances = [];
    this.isOrderFromLink = false;

    let valueFromUrlParam = +this.route.snapshot.queryParamMap.get("DocEntry");


    if (valueFromUrlParam && valueFromUrlParam > 0) {
      this.storage.SaveDocEntry(valueFromUrlParam);
      localStorage.setItem(
        "SOAndSQAction",
        SOAndSQActions.EditOrder.toString()
      );
      this.isOrderFromLink = this.isAutBtn = true;
    }

    this.router.navigate([], {
      queryParams: {
        'DocEntry': null
      },
      queryParamsHandling: 'merge'
    });

    this.DOC_ENTRY = this.storage.GetDocEntry();

    this.canAuthorize = false;


    this.isOnCreation = true;
    this.typeArrow = false;
    this.typeArrow2 = true;
    this.onSubmitButtonPrefix = "Crear órden de venta";

    this.defaultGroupNum = PayTermsEnum.Contado.toString();
    this.defaultListNum = "-1";
    this.tableLength = 1000;
    this.MapWidth = {};
    this.MapWidth["Id"] = 80;
    this.MapWidth["ItemCode"] = 350;
    this.MapWidth["UnitPrice"] = 100;
    this.MapWidth["Marca"] = 200;
    this.MapWidth["Group"] = 200;
    this.MapWidth["Quantity"] = 40;
    this.MapWidth["SubGroup"] = 100;
    this.MapWidth["ItemName"] = 350;
    this.MapWidth["Discount"] = 80;
    this.MapWidth["TaxRate"] = 80;
    this.MapWidth["TaxCode"] = 50;
    this.MapWidth["WhsCode"] = 60;
    this.MapWidth["WhsName"] = 100;
    this.MapWidth["UPWT"] = 100;
    this.MapWidth["LastDate"] = 80;
    this.MapWidth["LinTot"] = 100;
    this.MapWidth["Serie"] = 100;
    this.MapWidth["Opc"] = 100;

    this.btnVisibleBool = true;
    this.conta = 0;
    this.total = 0;
    this.totalUSD = 0;
    this.tax = 0;
    this.discount = 0;
    this.documentLevelDiscount = 0;
    this.totalWithoutTax = 0;
    this.DailyExRate = 0;
    this.provinceId = "0";
    this.cantonId = "0";
    this.districtId = "0";
    this.neighborhoodId = "0";
    this.hasLines = false;
    this.isEditingPrice = false;
    this.isCashCustomer = false;
    this.saleDocumentModel = null;

    this.identificationTypeList = IdentificationType;

    this.setWarehouseInfo();
    this.createFEForm();
    this.generateUniqueInvoiceId();
    this.GetTypeaheadSettings();
    this.correctSO = false;
  }

  OnLoad(): void {
    this.InitForm();
    this.LoadInitialData();
    this.InitDocument();
  }

  /**
   * Component initialization
   */
  ngOnInit(): void {
    this.eventManager = this.commonService.eventManager.subscribe(
      async (next) => {
        if (next) {

          if (next.ViewName.filter((x) => this.router.url.includes(x)).length > 0) {
            switch (next.FunctionName) {
              case "redirectToSoAndSQ":
                if (!this.isDocumentSubmitted && this.itemsList.length > 0) {
                  let confirmationResult =
                    await this.alertService.ConfirmationAlert(
                      "Confirmación",
                      `No ha guardado el ¿Desea continuar?`,
                      "Continuar"
                    );
                  if (!confirmationResult) return;
                  this.router.navigate(["SOandSQ"]);
                } else {
                  this.router.navigate(["SOandSQ"]);
                }
                break;
            }
          }
        }
      }
    );

    this.OnLoad();
  }

  private InitForm(): void {
    this.soForm = this.fb.group({
      cardCode: ['', Validators.required],
      cardName: [""],
      currency: ["", Validators.required],
      PayTerms: ["0"],
      SlpList: ["", Validators.required],
      BillOverdue: ["1", Validators.required],
      PaymentMethod: ["01", Validators.required],
      ActividadReceptor: [""],
      CondicionVenta: ["", Validators.required],
      CondicionVentaOtros: [""],
      Comment: "",
      NumAtCard: "",
      Discount: [0],
      tipoDocumento: ["TE"],
    });

    this.autForm = this.fb.group({
      Estado: ["", Validators.required],
      Observacion: [""],
      Autorizador: [""],
    });

    this.soForm.controls['CondicionVenta'].valueChanges.subscribe(value => {
      if (value === '99') {
        this.soForm.controls['CondicionVentaOtros'].enable();
        this.soForm.controls['CondicionVentaOtros'].setValidators([Validators.required, Validators.maxLength(100)]);
      } else {
        this.soForm.controls['CondicionVentaOtros'].clearValidators();
        this.soForm.controls['CondicionVentaOtros'].setValue('');
        this.soForm.controls['CondicionVentaOtros'].disable();
      }
      this.soForm.controls['CondicionVentaOtros'].updateValueAndValidity();
    });
  }

  private preselectTipoDocumento(actividadReceptor: string): void {
    const tipo = actividadReceptor ? 'FE' : 'TE';
    this.soForm.controls['tipoDocumento'].setValue(tipo);
  }

  isFEIncomplete(): boolean {
    if (this.soForm.value.tipoDocumento !== 'FE') return false;
    if (!this.soForm.value.ActividadReceptor) return true;
    if (this.isCashCustomer) {
      return !this.feForm.value.Identification || !this.feForm.value.Email;
    }
    return false;
  }

  /**
   * Method obtains initial requests
   * @constructor
   * @private
   */
  private InitDocument(): void {

    this.blockUI.start("Procesando, espere por favor...");
    let messageError = '';

    const observables: { [key: string]: Observable<any> } = {
      Customer: this.bpService.GetBussinesPartnerByCardCode(this.storage.getBranchOffice().CashBusinessPartnerCode),
      Perms: this.sPerm.getPerms(this.currentUser.userId),
      PaymentMethods: this.companyService.GetPaymentMethods(),
      SaleConditions: this.companyService.GetSaleConditions(),
      DiscountTypes: this.companyService.GetDiscountTypes(),
      ExchangeRate: this.exrate.getExchangeRate(),
      MaxDiscout: this.documentService.getMaxDiscout(),
      ParamView: this.paramsService.getParasmView(),
      UserList: this.uService.getUserList(),
      SalesMan: this.smService.getSalesMan(),
      Companies: this.companyService.GetCompanies(),
      Currency: this.paramsService.GetCurrencyType(),
      PayTerms: this.itemService.GetPayTerms(),
      Taxes: this.taxService.GetTaxes()
    };

    const observablesArray: Observable<any>[] = Object.values(observables);

    forkJoin(observablesArray).pipe(
      switchMap(([CustomerResponse, PermsResponse, PaymentMethodsResponse, SaleConditionsResponse, DiscountTypesResponse,
        ExchangeRateResponse, MaxDiscountResponse, ParamViewResponse, UserListResponse,
        SalesManResponse, CompaniesResponse, CurrencyResponse,
        PayTermsResponse, TaxesResponse]) => {

        //#region Load Data

        //#region Parametrizaciones

        if(ParamViewResponse.result){

          this.viewParamList = ParamViewResponse.Params.filter((param) => {
            return param.type === 1 && param.Visibility;
          });

          this.viewParamList.splice(7, 0, {
            CompanyId: 4,
            Descrip: "Precio unitario con impuesto",
            Display: true,
            Id: 144,
            Name: "UPWT",
            Order: 15,
            ParamsId: 11,
            Text: "Precio+Imp",
            ViewsId: 1,
            Visibility: true,
            type: 1,
          });

          this.tableLength = 0;
          for (var i = 0; i < this.viewParamList.length; i++) {
            this.tableLength += this.MapWidth[this.viewParamList[i].Name];
          }
          this.viewParamListHeader = ParamViewResponse.Params.filter((param) => {
            return param.type === 2;
          });
          this.viewParamListTotales = ParamViewResponse.Params.filter((param) => {
            return param.type === 3;
          });
          this.viewParamTitles = ParamViewResponse.Params.filter((param) => {
            return param.type === 6;
          });

          this.ChargeParamstoView();
        }else {
          messageError += `Error: Código: ${ParamViewResponse.errorInfo.Code}, Mensaje: ${ParamViewResponse.errorInfo.Message}`
        }
        // endregion
        //#region Permisos
        if(PermsResponse.result){

          this.isPriceEditable = PermsResponse.perms.find(
            (x) => x.Name === "P_EditPrice"
          ).Active;

          this.isPermAutorizeSale = PermsResponse.perms.find(
            (x) => x.Name === "Perm_Authorize_Sale"
          ).Active;

          PermsResponse.perms.forEach((Perm) => {
            if (Perm.Name === "V_SO") {
              this.permisos = Perm.Active;
            }
          });

        } else {
          messageError += `Error: Código: ${PermsResponse.errorInfo.Code}, Mensaje: ${PermsResponse.errorInfo.Message}`
        }
        // endregion
        //#region Customer
        if(CustomerResponse.result){
          this.businessPartnerDefault = CustomerResponse.BusinessPartner;

          // Solo asignar el socio de caja por defecto si NO estamos editando un documento existente
          // En modo edición, el socio correcto se carga después desde el documento
          if (this.DOC_ENTRY <= 0) {
            this.businessPartnersSelect = CustomerResponse.BusinessPartner;
            this.ChangeCode(this.storage.getBranchOffice().CashBusinessPartnerCode);
            this.SetDefaultBP();
          }
        } else {
          messageError += `Error: Código: ${CustomerResponse.errorInfo.Code}, Mensaje: ${CustomerResponse.errorInfo.Message}`
        }


        // endregion

        if(PaymentMethodsResponse.result){
          this.paymentMethods = PaymentMethodsResponse.PaymentMethods;

        }else {
          messageError += `Error: Código: ${PaymentMethodsResponse.errorInfo.Code}, Mensaje: ${PaymentMethodsResponse.errorInfo.Message}`
        }

        if(SaleConditionsResponse.result){
          this.saleConditions = SaleConditionsResponse.SaleConditions;
          this.soForm.controls['CondicionVenta'].setValue(this.saleConditions[0].Value);
        }else {
          messageError += `Error: Código: ${SaleConditionsResponse.errorInfo.Code}, Mensaje: ${SaleConditionsResponse.errorInfo.Message}`
        }

        if(DiscountTypesResponse.result){
          this.discountTypes = DiscountTypesResponse.DiscountTypes;
        }else {
          messageError += `Error: Código: ${SaleConditionsResponse.errorInfo.Code}, Mensaje: ${SaleConditionsResponse.errorInfo.Message}`
        }

        if(ExchangeRateResponse.result){
          this.DailyExRate = ExchangeRateResponse.exRate;

        }else {
          messageError += `Error: Código: ${ExchangeRateResponse.errorInfo.Code}, Mensaje: ${ExchangeRateResponse.errorInfo.Message}`
        }

        if(MaxDiscountResponse.result){
          this.maxDiscuont = MaxDiscountResponse.discount;

        }else {
          messageError += `Error: Código: ${MaxDiscountResponse.errorInfo.Code}, Mensaje: ${MaxDiscountResponse.errorInfo.Message}`
        }

        //#region User

        if(UserListResponse.result){
          this.userAssignsList = UserListResponse.Users;
          this.userAssignsList.forEach((user) => {
            if (this.currentUser.userId.toString() === user.UserId.toString()) {
              this.defaultSlpCode = user.SlpCode;
              this.defaultListNum = user.PriceListDef;
            }
          });
        }else {
          messageError += `Error: Código: ${UserListResponse.errorInfo.Code}, Mensaje: ${UserListResponse.errorInfo.Message}`
        }
        //endregion
        //#region Vendedores

        if(SalesManResponse.result){
          this.slpTypeaheadList = SalesManResponse.salesManList.map(element => ({
            SlpCode: element.SlpCode,
            SlpName: element.SlpName,
            TypeAheadFormatt: `${element.SlpCode} ${element.SlpName}`
          }));
        }else {
          messageError += `Error: Código: ${SalesManResponse.errorInfo.Code}, Mensaje: ${SalesManResponse.errorInfo.Message}`
        }
        //endregion
        //#region companias

        if(CompaniesResponse.result){
          this.companiesList = CompaniesResponse.companiesList;
          this.companiesList.forEach((comp) => {
            this.pesoBolsa = comp.ScaleWeightToSubstract;
            this.priceEditable = comp.IsLinePriceEditable;
            this.maxWeightTo0 = comp.ScaleMaxWeightToTreatAsZero;
          });
        }else {
          messageError += `Error: Código: ${CompaniesResponse.errorInfo.Code}, Mensaje: ${CompaniesResponse.errorInfo.Message}`
        }
        //endregion
        //#region Currency

        if(CurrencyResponse.length > 0){
          this.currencyList = CurrencyResponse;
          this.allCurrencyList = CurrencyResponse;

        }else {
          messageError += `Error: Código: ${CurrencyResponse.errorInfo.Code}, Mensaje: ${CurrencyResponse.errorInfo.Message}`
        }
        //endregion
        //#region PayTerms
        if(PayTermsResponse.result){
          this.PayTermsList = PayTermsResponse.payTermsList;
        }else {
          messageError += `Error: Código: ${PayTermsResponse.errorInfo.Code}, Mensaje: ${PayTermsResponse.errorInfo.Message}`
        }
        //endregion
        //#region Taxes

        if(TaxesResponse.result){
          this.taxesList = TaxesResponse.Taxes;
          this.taxesList.push({
            TaxCode: "EXE",
            TaxRate: "0.00",
          });
        }else {
          messageError += `Error: Código: ${TaxesResponse.errorInfo.Code}, Mensaje: ${TaxesResponse.errorInfo.Message}`
        }

        this.SetInitialData();
        if (this.DOC_ENTRY > 0) {
          switch (Number(localStorage.getItem("SOAndSQAction"))) {
            case SOAndSQActions.EditOrder: {
              this.isOnCreation = false;
              this.onSubmitButtonPrefix = "Actualizar órden de venta";
              this.soForm.controls["cardName"].disable();
              this.soForm.controls["cardCode"].disable();
              return this.soAdnSQService.GetSaleOrder(this.DOC_ENTRY);
              break;
            }
            case SOAndSQActions.CopyToOrder: {
              return this.soAdnSQService.GetSaleQuotationToCopy(this.DOC_ENTRY);
              break;
            }
            case SOAndSQActions.DuplicateSaleOrder: {
              return this.soAdnSQService.GetSaleOrder(this.DOC_ENTRY);
            }
              break;
            default:  return of(null);
          }
        } else {
          return of(null);
        }

        //#endregion
        //endregion

      }),
      switchMap(res =>{
        if (res) {
          if(res.result) {
            this.saleDocumentModel = res.Data;
            this.baseLines = res.Data.DocumentLines;
            // Limpiar itemsList ANTES de cargar el cliente para evitar que SetDataBPLines
            // llame a setupRecalculate() con ítems residuales de ediciones previas
            this.itemsList = [];
            this.conta = 0;
            this.total = 0;
            // NO ejecutar SetDocument() y SetDocumentLines() aquí para evitar race condition
            // Se ejecutarán después de cargar el cliente correcto

          }else {
            messageError += `Error: Código: ${res.errorInfo.Code}, Mensaje: ${res.errorInfo.Message}`
          }
        }

        if(this.DOC_ENTRY <= 0){
          return this.bpService.CheckIfBPHaveAnyPending(this.DEFAULT_BUSINESS_PARTNER);
        } else{
          // Guardar el CardCode del documento ANTES de cualquier operación
          const documentCardCode = res.Data.CardCode;

          return this.bpService.GetBussinesPartnerByCardCode(documentCardCode).pipe(
              switchMap(
                bp => {
                  // Validar que el socio obtenido corresponde al documento
                  if (!bp || !bp['BusinessPartner']) {
                    throw new Error('No se pudo obtener el socio de negocio');
                  }

                  const obtainedCardCode = bp['BusinessPartner'].CardCode;
                  if (obtainedCardCode !== documentCardCode) {
                    throw new Error(`Error: Se obtuvo un socio incorrecto`);
                  }

                  // IMPORTANTE: Establecer cliente correcto ANTES de SetDocument()
                  this.businessPartnersSelect = bp['BusinessPartner'];

                  // Ejecutar SetDocument() primero (ahora con businessPartnersSelect correcto)
                  this.SetDocument();

                  // Luego ejecutar SelectRecordBpOnEdition para completar la configuración
                  // (actualiza formularios y llama SetDataBPLines para establecer priceList)
                  this.SelectRecordBpOnEdition(bp['BusinessPartner']);

                  // Finalmente cargar las líneas con todo configurado correctamente
                  if (Number(localStorage.getItem("SOAndSQAction")) === SOAndSQActions.CopyToOrder) {
                    this.SetDocumentBaseLines();
                  } else {
                    this.SetDocumentLines();
                  }

                  return this.bpService.CheckIfBPHaveAnyPending(documentCardCode);
                }
              )
          );
        }
      }),
      finalize(() => {
        this.blockUI.stop();
        if(messageError.length > 0){
          this.alertService.errorAlert(
            `${messageError}`
          );
        }}),
      catchError(err => {
        this.alertService.errorInfoAlert(
          `Error: ${err}`
        );
        return of(null);
      })
    ).subscribe({
      next: res => {
        if(res) {
          if (res.result) {
            this.showBtnBPContacs = false;

            if (res.Data.PayTermGroup != -1) {
              this.showBtnBPContacs = true;
            }
            if (res.Data.PayTermGroup != -1 && res.Data.RequiredAutorization) {
              this.alertService.infoAlert(
                "Tiene documentos pendientes de pago, realizar gestión de cobro."
              );
              this.BpDocuemntPendingPay = res.Data.RequiredAutorization;
            }

            if (
              this.storage.GetUIAction() !== SOAndSQActions.EditOrder &&
              this.BpDocuemntPendingPay &&
              this.soForm.controls.PayTerms.value === "1"
            ) {
              this.onSubmitButtonPrefix = "Enviar órden a autorización";
            }
          } else {
            messageError += `Error: Código: ${res.errorInfo.Code}, Mensaje: ${res.errorInfo.Message}`
          }
        }
        this.getTotals();
      },
      error: err => {
        this.alertService.errorInfoAlert(
          `Error al intentar conectar con el servidor, Error: ${err}`
        );
      }
    });
  }

  ngAfterViewInit() { }

  GetPaymentMethods(): void {
    this.blockUI.start("Procesando medios de pago, espere por favor...");
    this.companyService.GetPaymentMethods().subscribe((next) => {
      if (next.result) {
        this.blockUI.stop();
        this.paymentMethods = next.PaymentMethods;
        if (this.saleDocumentModel !== null) {
          this.soForm.patchValue({
            PaymentMethod: this.saleDocumentModel.U_NVT_Medio_Pago,
          });
        }
      } else {
        this.blockUI.stop();
        console.log(next);
      }
    },
      (error) => {
        this.blockUI.stop();
        this.alertService.errorInfoAlert(
          `Error al intentar conectar con el servidor, Error: ${error}`
        );
      });
  }

  checkPermits() {
    this.blockUI.start("Procesando, espere por favor...");
    this.sPerm.getPerms(this.currentUser.userId).subscribe(
      (data: any) => {
        this.blockUI.stop();
        if (data.result) {
          this.isPriceEditable = data.perms.find(
            (x) => x.Name === "P_EditPrice"
          ).Active;

          this.isPermAutorizeSale = data.perms.find(
            (x) => x.Name === "Perm_Authorize_Sale"
          ).Active;

          data.perms.forEach((Perm) => {
            if (Perm.Name === "V_SO") {
              this.permisos = Perm.Active;
              if (this.permisos) {
                this.nameField.nativeElement.focus();
              }
            }
          });

        } else {
          this.permisos = false;
        }
      },
      (error) => {
        console.log(error);
        this.permisos = false;
        this.blockUI.stop();
      }
    );
  }

  setSalesPerson() {
    this.blockUI.start("Cargando listas de usuarios...");
    this.uService.getUserList().subscribe(
      (data: any) => {
        this.blockUI.stop();
        if (data.result) {
          this.userAssignsList = data.Users;
          this.userAssignsList.forEach((user) => {
            if (this.currentUser.userId.toString() === user.UserId.toString()) {
              this.defaultSlpCode = user.SlpCode;
              this.defaultListNum = user.PriceListDef;
            }
          });
          this.GetSalesPersonList();
        } else {
          this.blockUI.stop();
          this.alertService.errorAlert(
            "Error al cargar la lista de usuarios - " + data.errorInfo.Message
          );
        }
      },
      (error) => {
        this.blockUI.stop();
        this.alertService.errorInfoAlert(
          `Error al intentar conectar con el servidor, Error: ${error}`
        );
      }
    );
  }

  // obtiene el tipo de cambio
  getExRate() {
    this.blockUI.start("Obteniendo Tipos de Cambio, Espere Por Favor...");
    this.exrate.getExchangeRate().subscribe(
      (data: any) => {
        this.blockUI.stop();
        if (data.result) {
          this.DailyExRate = data.exRate;
          this.currentRequest++;
          this.$requestViewer.next(this.currentRequest);
        } else {
          this.alertService.errorAlert(
            `Error: Código: ${data.errorInfo.Code}, Mensaje: ${data.errorInfo.Message}`
          );
        }
      },
      (error: any) => {
        this.blockUI.stop();
        this.alertService.errorInfoAlert(
          `Error getCustomers!!!, Error: ${error.error.Message}`
        );
      }
    );
  }

  createFEForm() {
    this.feForm = this.fb.group({
      IdType: ["", Validators.required],
      Identification: ["", Validators.required],
      Email: [""],
      ObservacionFE: [""],
    });

    this.feForm.patchValue({ IdType: this.identificationTypeList[0].Id });
  }

  redirectToSOSQ(): void {
    this.router.navigate(["SOandSQ"]);
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.commonService.hasDocument.next(``);
    this.storage.SaveBreadCrum(``);
    this.currentUserSubscription.unsubscribe();
    this.storage.SaveDocEntry(-1);
    this.storage.SaveCustomerData("{}");
    this.eventManager.unsubscribe();
    localStorage.removeItem("SOAndSQAction");
  }

  getMaxDiscout() {
    this.blockUI.start("Procesando descuentos, espere por favor...");
    this.documentService.getMaxDiscout().subscribe(
      (data: any) => {
        this.blockUI.stop();
        if (data.result) {
          this.currentRequest++;
          this.maxDiscuont = data.discount;
          this.$requestViewer.next(this.currentRequest);
        } else {
          this.alertService.errorAlert(
            `Error: Código: ${data.errorInfo.Code}, Mensaje: ${data.errorInfo.Message}`
          );
        }
      },
      (error: any) => {
        this.blockUI.stop();
        this.alertService.errorInfoAlert(
          `Error getCustomers!!!, Error: ${error.error.Message}`
        );
      }
    );
  }

  // funcion para obtener los impuestos desde SAP
  // no recibe parametros
  getTaxes() {
    this.blockUI.start("Obteniendo Impuestos, Espere Por Favor...");
    this.taxService.GetTaxes().subscribe(
      (data: any) => {
        if (data.result) {
          this.taxesList.length = 0;
          this.taxesList = data.Taxes;
          this.taxesList.push({
            TaxCode: "EXE",
            TaxRate: "0.00",
          });
        } else {
        }
        this.blockUI.stop(); // Stop blocking
      },
      (error: any) => {
        this.blockUI.stop(); // Stop blocking
        this.alertService.errorInfoAlert(
          `Error getTaxes!!!, Error: ${error.error.Message}`
        );
      }
    );
  }
  // funcion para obtener los clientes desde SAP
  // recibe como parametros el item y el index
  selectedItem(item, idx) {
    if (item.item !== "") {

      this.blockUI.start(
        "Obteniendo Información del Artículo, Espere Por Favor..."
      );
      this.itemService
        .GetItemByItemCode(
          item.item.split(" COD. ")[0],
          this.priceList,
          this.soForm.controls.cardCode.value
        )
        .subscribe(
          (data: any) => {
            if (data.result) {
              this.itemsList[idx].ItemCode = data.Item.ItemCode;
              this.itemsList[idx].ItemName = data.Item.ItemName;
              this.itemsList[
                idx
              ].Item = `${data.Item.ItemCode} - ${data.Item.ItemName}`;
              this.itemsList[idx].UnitPrice = data.Item.UnitPrice;
              this.itemsList[idx].U_SugPrice = data.Item.UnitPrice;
              this.itemsList[idx].TaxCode =
                data.Item.TaxMAGRate > 0
                  ? data.Item.TaxMAGCode
                  : data.Item.TaxCode;
              this.itemsList[idx].TaxRate =
                data.Item.TaxMAGRate > 0
                  ? data.Item.TaxMAGRate
                  : data.Item.TaxRate;
              this.itemsList[idx].TaxMAGCode = data.Item.TaxMAGCode;
              this.itemsList[idx].TaxMAGRate = data.Item.TaxMAGRate;
              this.itemsList[idx].DiscountPercent = data.Item.Discount;
              this.itemsList[idx].LinTot = parseFloat(data.Item.UnitPrice);
              this.itemsList[idx].Active = false;

              this.conta++;
              this.total += data.Item.UnitPrice;
              let itemAux = {
                Item: "",
                ItemCode: "",
                ItemName: "",
                UnitPrice: 0,
                U_SugPrice: 0,
                TaxCode: "EXE",
                Quantity: 1,
                Active: true,
                Id: this.conta,
                LinTot: 0,
                TaxRate: 0.0,
                DiscountPercent: item.DiscountPercent,
                WarehouseCode: this.whCode,
                WhsName: this.whName,
                Serie: "",
                SysNumber: 0,
                U_NVT_ServicioMedico: 0,
              } as IDocumentLine;

              this.itemsList.push(itemAux);
              this.getTotals();
            } else {
              this.alertService.errorAlert(
                `Error: no se pudo obtener la información del item solicitado: Código: ${data.errorInfo.Code}, Mensaje: ${data.errorInfo.Message}`
              );
            }
            this.blockUI.stop(); // Stop blocking
          },
          (error: any) => {
            this.blockUI.stop(); // Stop blocking
            this.alertService.errorInfoAlert(
              `Error al intentar conectar con el servidor, Error: ${error}`
            );
          }
        );
    }
  }
  // funcion para eliminar el item de la lista
  // recibe como parametro el item a eliminar
  removeItem(item) {
    const index = this.itemsList.indexOf(item);
    this.itemsList.splice(index, 1);
    this.getTotals();
  }
  // convenience getter for easy access to form fields
  get f() {
    return this.soForm.controls;
  }
  get fe() {
    return this.feForm.controls;
  }
  // funcion para el envio de la SO a SAP
  // no recibe parametros
  onSubmit() {
    this.isOnPrint = false;
    if (this.itemsList.length === 0) {
      this.alertService.errorInfoAlert(
        `Por favor agregue un producto al menos`
      );
      this.isOnSubmit = false;
      return;
    }
    this.submitted = true;

    if (this.soForm.value.CondicionVenta === "99" && this.soForm.value.CondicionVentaOtros === "") {
      this.alertService.errorInfoAlert(`Para el código 99 debe ingresar una descripción en el campo "Condición de Venta Otros"`);
      this.isOnSubmit = false;
      return;
    }

    if (this.soForm.invalid) {
      this.isOnSubmit = false;
      return;
    }

    // Esta validación solo aplica para documentos nuevos, NO para edición
    // En modo edición, el cardName ya fue cargado desde el documento en SetDocument()
    if (!this.soForm.value.cardName && this.storage.GetUIAction() !== SOAndSQActions.EditOrder) {
      let cardName = "";
      if (
        this.storage.GetDocEntry() > 0 &&
        +localStorage.getItem("SOAndSQAction") !==
        SOAndSQActions.DuplicateSaleOrder
      ) {
        let customer =this.businessPartnerDefault;
        if (customer) {
          cardName = customer.CardName;
          this.soForm.patchValue({cardName: cardName});
        }
      }
    }


    if (this.itemsList.some((x) => x.LinTot == 0)) {
      this.alertService.errorInfoAlert(`Existen lineas con costo 0`);
      this.isOnSubmit = false;
      return;
    }

    this.btnVisibleBool = false;

    let documentType = this.soForm.value.tipoDocumento;
    let SLP = this.soForm.controls.SlpList.value as ISaleMan;
    let SLPList = this.slpTypeaheadList.find(x => x.SlpCode === SLP.SlpCode);
    if (SLPList) {
      if (SLP && SLP.SlpCode === "-1") {
        this.isSalesManSelected = false;
        this.isOnSubmit = false;
        return;
      }
    } else {
      this.isSalesManSelected = false;
      this.isOnSubmit = false;
      return;
    }
    this.UdfsInDocument.map(x => {
      x.Value = null;
      return x;
    });

    this.SetValueUDF<string>(
      "FacturaVencida",
      this.soForm.value.BillOverdue === "0" ? "SI" : "NO"
    );
    this.SetValueUDF<string>(
      "Facturacion",
      this.soForm.value.PayTerms === "0" ? "Contado" : "Credito"
    );
    this.SetValueUDF<string>("NVT_Medio_Pago", this.soForm.value.PaymentMethod);

    if (!this.isOrderFromLink) {
      this.SetValueUDF<string>("Almacen", this.storage.getBranchOffice().Code);
    }
    this.SetValueUDF<string>("CLVS_POS_UniqueInvId", this.uniqueInvCode);

    // FE 4.4

    this.SetValueUDF<string>("ActividadReceptor", this.soForm.value.ActividadReceptor);

    this.SetValueUDF<string>("CondicionVenta", this.soForm.value.CondicionVenta);

    this.SetValueUDF<string>("CondicionVentaOtros", this.soForm.value.CondicionVentaOtros);

    this.SetValueUDF<string>("TipoDocE", documentType);

    if(this.feForm.value.IdType && +this.feForm.value.IdType !=0 && this.feForm.value.IdType!= 99){

      if(this.feForm.value.Identification && this.feForm.value.Email){
        this.SetValueUDF<string>("TipoIdentificacion", this.feForm.value.IdType);
        this.SetValueUDF<string>("CorreoFE", this.feForm.value.Email);
        this.SetValueUDF<string>("NumIdentFE", this.feForm.value.Identification);
      }

      if(this.feForm.value.ObservacionFE){
        this.SetValueUDF<string>("ObservacionFE", this.feForm.value.ObservacionFE);
      }

    }

    if (this.storage.GetUIAction() == SOAndSQActions.EditOrder) {
      if (this.soForm.controls.PayTerms.value == 1) {
        let estadoOVValue =
          this.BpDocuemntPendingPay && !this.canAuthorize
            ? "02"
            : this.autForm.controls.Estado.value;
        this.SetValueUDF<string>("EstadoOV", estadoOVValue);

        if (this.canAuthorize) {
          this.SetValueUDF<string>(
            "ObservacionAut",
            this.autForm.controls.Observacion.value
          );
          this.SetValueUDF<string>(
            "FechaAut",
            this.datePipe.transform(new Date(), "yyyy-MM-dd-h:mm:ss a")
          );
          this.SetValueUDF<string>(
            "CorreoAut",
            JSON.parse(this.storageService.getCurrentSession()).UserName
          );
        }
      }
    } else {
      if (
        this.soForm.controls.PayTerms.value == 1 &&
        this.BpDocuemntPendingPay
      ) {
        this.SetValueUDF<string>("EstadoOV", "02");
      }
    }

    if (
      this.storage.GetDocEntry() < 0 &&
      this.BpDocuemntPendingPay &&
      this.soForm.controls.PayTerms.value === "1"
    ) {
      console.log("Envio udf estado pendiente");
    }

    if ((this.itemsList.length - 1) < this.IndexMinDocument) {
      this.IndexMaxUpdate = -1;
    }

    let linesList: IDocumentLine[] = this.itemsList.map((line, index) => {
      line.LineNum == -1 ? this.IndexMaxUpdate = this.IndexMaxUpdate + 1 : this.IndexMaxUpdate;

      let item = {
        ItemCode: line.ItemCode.split("-")[0].trim(),
        DiscountPercent: line.DiscountPercent,
        Quantity: line.Quantity,
        TaxCode: line.TaxCode,
        TaxRate: line.TaxRate,
        UnitPrice: line.UnitPrice,
        WarehouseCode: line.WarehouseCode,
        LineNum: line.LineNum == -1 ? this.IndexMaxUpdate : line.LineNum,
        BaseEntry: line.BaseEntry,
        BaseLine: line.BaseLine,
        BaseType: line.BaseType || -1,
        LineStatus: line.LineStatus,
        U_NVT_ServicioMedico: line.U_NVT_ServicioMedico,
        TaxCode_BCK: line.TaxCode_BCK,
        U_TipoDescuento: line.U_TipoDescuento,
        U_DescuentoOtros: line.U_DescuentoOtros
      } as IDocumentLine;

      return item;
    });

    if (this.storage.GetDocEntry() > 0) {
      if (
        this.baseLines &&
        Number(localStorage.getItem("SOAndSQAction")) ===
        SOAndSQActions.CopyToOrder
      ) {
        let documentEntry = this.storage.GetDocEntry();
        this.baseLines.forEach((i) => {
          let aux = linesList.find(
            (x) => x.ItemCode === i.ItemCode && !x["read"]
          );
          if (aux) {
            aux["read"] = true;
            aux.BaseEntry = documentEntry;
            aux.BaseLine = i.BaseLine;
            aux.BaseType = BaseTypeLines.SALE_ORDER;
          }
        });
      }

    }

    let docEntry: number =
      this.storage.GetUIAction() == SOAndSQActions.EditOrder
        ? this.storage.GetDocEntry()
        : 0;

    const mappedUdfs: IUdf[] = this.UdfsInDocument.filter(x=>x.Value).map(udf => {
      return {
        Name: udf.Description,
        Value: udf.Value,
        FieldType: udf.Type
      };
    });

    const cardNameString = this.ResolveCardNameToSend();

    let saleOrder = {
      DocEntry: docEntry,
      BaseEntry: this.storage.GetDocEntry(),
      CardCode: this.soForm.controls.cardCode.value,
      CardName: cardNameString,
      Comments: this.soForm.controls.Comment.value,
      DocCurrency: this.soForm.controls.currency.value,
      SalesPersonCode: Number(SLP.SlpCode),
      Udfs: mappedUdfs,
      DocumentLines: linesList,
      DocType: BoDocumentTypes.dDocument_Items,
      NumAtCard: this.soForm.value.NumAtCard,
      DiscountPercent: this.documentLevelDiscount, // Preservar descuento a nivel de documento
    } as SLDocument;
    saleOrder.StringedDocument = JSON.stringify(saleOrder);
    if (this.storage.GetUIAction() == SOAndSQActions.EditOrder) {
      // Validar que no haya una petición en curso para evitar duplicados
      if (this.isOnSubmit) {
        return; // Ya hay una petición en proceso
      }
      this.isOnSubmit = true;

      this.blockUI.start("Actualizando orden de venta, espere por favor...");
      this.documentService.UpdateSaleOrder(saleOrder).subscribe(
        data => {
          this.blockUI.stop();
            this.dateTimeExitUI = formatDate(
              new Date(),
              "yyyy-MM-dd HH:mm:ss SSS a",
              "en"
            );
            this.isOnPrint = true;
            this.baseLines = null;
            this.lastSO = this.saleDocumentModel.DocEntry;
            this.returnedDocEntry = this.saleDocumentModel.DocEntry;
            this.returnedDocNum = this.saleDocumentModel.DocNum;
            this.btnVisibleBool = false;
            this.correctSO = false;
            this.isDocumentSubmitted = true;
            this.titleSaleOrder = "Orden de venta actualizada correctamente";
            (<HTMLButtonElement>(
              document.getElementById("triggerAfterPayModal")
            )).click();

          this.isOnSubmit = false;
        },
        (error: any) => {
          this.isDocumentSubmitted = false;
          this.blockUI.stop();
          this.isOnSubmit = false;
          let err = error && error.Code ? `Error al intentar actualizar orden de venta, Código: ${error.Code}, Mensaje: ${error.Message}`: '';
          this.alertService.errorAlert(err ? err :`Error al intentar conectar con el servidor, Error: ${error}`);
        }
      );
    } else {
      if (
        this.soForm.value.NumAtCard !== "" &&
        !Number(this.soForm.value.NumAtCard)
      ) {
        this.alertService.infoInfoAlert(`La cédula solo debe tener números`);
        this.isOnSubmit = false;
        return;
      }

      this.isRequiredEmail = false;

      if (this.hasIdentification && this.feForm.value.Email === "") {
        this.isRequiredEmail = true;
        this.alertService.infoInfoAlert(
          `El correo es requerido para completar la factura electrónica`
        );
        this.isOnSubmit = false;
        return;
      }

      if (this.correctSO) {
        this.alertService.infoInfoAlert(
          `Presione el boton de Limpiar Campos para poder crear una nueva orden`
        );
        this.isOnSubmit = false;
        return;
      }

      // Validar que no haya una petición en curso para evitar duplicados
      if (this.isOnSubmit) {
        return; // Ya hay una petición en proceso
      }
      this.isOnSubmit = true;

      this.blockUI.start("Procesando orden de venta, espere por favor...");
      this.documentService.CreateSaleOrder(saleOrder).subscribe(
        callback => {
          this.blockUI.stop();
          if (callback && callback.Data) {
            this.dateTimeExitUI = formatDate(
              new Date(),
              "yyyy-MM-dd HH:mm:ss SSS a",
              "en"
            );
            this.baseLines = null;
            this.lastSO = callback.Data.DocEntry;
            this.returnedDocEntry = callback.Data.DocEntry;
            this.returnedDocNum = callback.Data.DocNum;
            this.btnVisibleBool = false;
            this.correctSO = true;
            this.isDocumentSubmitted = true;
            this.titleSaleOrder = "Orden de venta creada con éxito";
            (<HTMLButtonElement>(
              document.getElementById("triggerAfterPayModal")
            )).click();
          } else {
            this.isDocumentSubmitted = false;
            this.alertService.errorAlert(
              `Error al intentar crear el documento, Código: ${callback.Error.Code}, Mensaje: ${callback.Error.Message}`
            );
          }
          this.isOnSubmit = false;
        },
        (error: any) => {
          this.isOnSubmit = false;
          this.isDocumentSubmitted = false;
          this.blockUI.stop();
          let err = error && error.Code ? `Error al intentar crear orden de venta, Código: ${error.Code}, Mensaje: ${error.Message}`: '';
          this.alertService.errorAlert(err ? err :`Error al intentar conectar con el servidor, Error: ${error}`);
        }
      );
    }

  }

  CreateSaleOrder(_documentType: string): void {
    if (
      this.soForm.value.NumAtCard !== "" &&
      !Number(this.soForm.value.NumAtCard)
    ) {
      this.alertService.infoInfoAlert(`La cédula solo debe tener números`);
      return;
    }

    this.isRequiredEmail = false;

    if (this.hasIdentification && this.feForm.value.Email === "") {
      this.isRequiredEmail = true;
      this.alertService.infoInfoAlert(
        `El correo es requerido para completar la factura electrónica`
      );
      return;
    }

    if (this.correctSO) {
      this.alertService.infoInfoAlert(
        `Presione el boton de Limpiar Campos para poder crear una nueva orden`
      );
      return;
    }

    this.blockUI.start("Creando orden de venta, espere por favor...");
    this.documentService
      .CreateSaleOrder2(
        this.soForm,
        this.itemsList,
        this.feForm,
        "",
        this.storage.GetDocEntry() > 0 ? this.baseLines : [],
        _documentType,
        this.uniqueInvCode
      )
      .subscribe(
        (data: any) => {
          this.blockUI.stop();
          if (data.result) {
            this.baseLines = null;
            this.lastSO = data.DocEntry;
            this.returnedDocEntry = data.DocEntry;
            this.returnedDocNum = data.DocNum;
            this.btnVisibleBool = false;
            this.correctSO = true;
            this.isDocumentSubmitted = true;
            this.titleSaleOrder = "Orden de venta creada con éxito";
            (<HTMLButtonElement>(
              document.getElementById("triggerAfterPayModal")
            )).click();
          } else {
            this.isDocumentSubmitted = false;
            this.alertService.errorAlert(
              `Error al intentar crear el documento, Código: ${data.errorInfo.Code}, Mensaje: ${data.errorInfo.Message}`
            );
          }
          this.isOnSubmit = false;
        },
        (error: any) => {
          this.isOnSubmit = false;
          this.isDocumentSubmitted = false;
          this.blockUI.stop();
          this.alertService.errorInfoAlert(
            `Error al intentar conectar con el servidor, Error: ${error}`
          );
        }
      );
  }

  UpdateSaleOrder(_documentType: string): void {
    this.blockUI.start("Actualizando orden de venta, espere por favor...");
    this.documentService
      .UpdateSaleOrder2(
        this.soForm,
        this.itemsList,
        this.feForm,
        "",
        this.storage.GetDocEntry() > 0 ? this.baseLines : [],
        _documentType
      )
      .subscribe(
        (data: any) => {
          this.blockUI.stop();
          if (data.result) {
            this.isOnPrint = true;
            this.baseLines = null;
            this.lastSO = data.DocEntry;
            this.returnedDocEntry = data.DocEntry;
            this.returnedDocNum = data.DocNum;
            this.btnVisibleBool = false;
            this.correctSO = false;
            this.isDocumentSubmitted = true;
            this.titleSaleOrder = "Orden de venta actualizada correctamente";
            (<HTMLButtonElement>(
              document.getElementById("triggerAfterPayModal")
            )).click();
          } else {
            this.isDocumentSubmitted = false;
            this.alertService.errorAlert(
              `Error al intentar actualizar el documento, Código: ${data.errorInfo.Code}, Mensaje: ${data.errorInfo.Message}`
            );
          }
          this.isOnSubmit = false;
        },
        (error: any) => {
          this.isDocumentSubmitted = false;
          this.blockUI.stop();
          this.isOnSubmit = false;
          console.log(error);
          this.alertService.errorInfoAlert(
            `Error al intentar conectar con el servidor, Error: ${error}`
          );
        }
      );
  }

  formatter = (slp: any) => slp.TypeAheadFormatt || slp;
  /**
   * Typeahead search business partner
   * @param businessPartner
   */
  formatterBusinessPartner = (businessPartner: IBusinessPartnerModel) => businessPartner.CardName || businessPartner;

  formatterCardCodeBusinessPartner = (businessPartner: IBusinessPartnerModel) => businessPartner.CardCode || businessPartner;


  searchSlpName = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term.length < 1
          ? []
          : this.slpTypeaheadList
            .filter(
              (v) =>
                v.SlpCode.toLowerCase().includes(term.toLowerCase()) ||
                v.SlpName.toLowerCase().includes(term.toLowerCase())
            )
            .slice(0, 10)
      )
    );

  /**
   * Searches for a business partner code based on the provided text.
   *
   * @param text$ An observable that emits the search text.
   */
  searchBPCode = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    // El catchError va DENTRO del switchMap: si el error escapa al operador externo, ngbTypeahead
    // pierde su suscripcion y el typeahead queda muerto por el resto de la sesion.
    switchMap(value => this.bpService.GetBussinesPartners(value, 1, this.typeaheadSettings.CustomersCounts)
      .pipe(
        map(term => (term && term.BusinessPartnerFilter) ? term.BusinessPartnerFilter : []),
        catchError(() => of([]))
      ))
  );

  /**
   * Searches for a business partner name based on the provided text.
   *
   * @param text$ An observable that emits the search text.
   */
  searchBPName = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(value => this.bpService.GetBussinesPartners(value, 1, this.typeaheadSettings.CustomersCounts)
        .pipe(
          map(term => (term && term.BusinessPartnerFilter) ? term.BusinessPartnerFilter : []),
          catchError(() => of([]))
        ))
    );

  /**
   * Searches for an item code based on the provided text.
   *
   * @param text$ An observable of the search text.
   * @returns An observable that emits search results.
   */
  searchItemCode = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(value => this.itemService.GetItemsSearch(value, 1, this.typeaheadSettings.ItemsCounts,'so')),
      map(term => (term.ItemList || []).map(item => item.FilterUpperCase))
    );

  /**
   * Funcion para detectar el cambio en el input de Código
   * @param $event -Recibe como parametro el Código del socio
   * @constructor
   */
  ChangeCode($event: any) {
    if ($event != null) {
      if (typeof $event === 'object') {
        let businessPartner = $event.item as IBusinessPartnerModel;
        $event.preventDefault();
        this.businessPartnersSelect = businessPartner;

        this.soForm.controls['cardCode'].setValue(businessPartner.CardCode);
        this.soForm.controls['ActividadReceptor'].setValue(businessPartner.U_ActividadReceptor);
        this.preselectTipoDocumento(businessPartner.U_ActividadReceptor);

        this.getCurrencyByUser(businessPartner.Currency);

        // Seleccionar otro socio explicitamente si reemplaza el nombre digitado
        this.isCardNameTypedByUser = false;
        if (businessPartner && businessPartner.CardName !== this.soForm.get("cardName").value) {
          this.soForm.patchValue({cardName: businessPartner.CardName});
        }
        this.SetDataBPLines(businessPartner.CardCode);
        this.VerifyStatusMagHA(businessPartner);
      }else if (typeof $event === 'string') {
        this.bpService.GetBussinesPartners($event,  1, this.typeaheadSettings.CustomersCounts)
          .pipe()
          .subscribe((data: any) => {
            if (data.result) {
              if (data.BusinessPartnerFilter) {
                let bpPartners = data.BusinessPartnerFilter[0] as IBusinessPartnerModel;
                this.businessPartnersSelect = bpPartners;
                this.soForm.controls['cardCode'].setValue(bpPartners.CardCode);
                this.soForm.controls['ActividadReceptor'].setValue(bpPartners.U_ActividadReceptor);
                this.preselectTipoDocumento(bpPartners.U_ActividadReceptor);
                this.getCurrencyByUser(bpPartners.Currency);
                // Esta respuesta es asincrona (carga del socio de Contado por defecto): si llega
                // despues de que el cajero digito un nombre, NO debe sobrescribirlo.
                if (bpPartners && !this.isCardNameTypedByUser
                    && bpPartners.CardName !== this.soForm.get("cardName").value) {
                  this.soForm.patchValue({cardName: bpPartners.CardName});
                }
                this.SetDataBPLines(bpPartners.CardCode);
                this.VerifyStatusMagHA(bpPartners);
              }
            } else {
              this.alertService.errorAlert(`Error: Código: ${data.errorInfo.Code}, Mensaje: ${data.errorInfo.Message}`);
            }
            this.blockUI.stop();
          }, (error: any) => {
            this.alertService.errorInfoAlert(`Error al intentar conectar con el servidor, Error: ${error}`);
          });
      }
    }
  }

  /**
   * Set data business partners
   * @param _cardCode
   * @constructor
   * @private
   */
  private SetDataBPLines(_cardCode: string): void{
    const customer = this.businessPartnersSelect;

    if (customer) {
      this.priceList = customer.ListNum;
      this.soForm.patchValue({ cardCode: _cardCode });
      this.getCurrencyByUser(customer.Currency);
      this.isCashCustomer = customer.QryGroup1 === "Y";
      this.triggerFECollapser(this.isCashCustomer, this.typeArrow);
    }

    if (this.itemsList.length > 0) {
      // Cambio de socio: el descuento de las lineas ya digitadas se recalcula contra el
      // grupo de descuento autorizado del socio nuevo (SDS-5487).
      this.setupRecalculate(true);
    }
  }

  CheckIfBPHaveAnyPending(_code :string):void {

    this.blockUI.start("Verificando datos del cliente, por favor espere..");
    this.BpDocuemntPendingPay = false;
    this.bpService.CheckIfBPHaveAnyPending(_code).subscribe(
      (info) => {
        this.blockUI.stop();

        if (info.result) {
          this.showBtnBPContacs = false;

          if (info.Data.PayTermGroup != -1) {
            this.showBtnBPContacs = true;
          }
          if (info.Data.PayTermGroup != -1 && info.Data.RequiredAutorization) {
            this.alertService.infoAlert(
              "Tiene documentos pendientes de pago, realizar gestión de cobro."
            );
            this.BpDocuemntPendingPay = info.Data.RequiredAutorization;
          }

          if (
            this.storage.GetUIAction() !== SOAndSQActions.EditOrder &&
            this.BpDocuemntPendingPay &&
            this.soForm.controls.PayTerms.value === "1"
          ) {
            this.onSubmitButtonPrefix = "Enviar órden a autorización";
          } else if (this.storage.GetDocEntry() > 0) {
            this.onSubmitButtonPrefix = "Actualizar órden de venta";
          } else {
            this.onSubmitButtonPrefix = "Crear órden de venta";
          }
        }
      },
      (err) => {
        this.blockUI.stop();
        this.alertService.errorAlert(
          "Ocurrio un error verificando los datos del cliente, causado por: " +
          err
        );
      }
    );
  }

  /**
   * Recalcula las lineas del documento contra la lista de precios y el socio actuales.
   *
   * El comportamiento correcto DEPENDE DE QUIEN LLAMA, por eso el disparador se pasa
   * explicitamente y no se deduce del estado del componente:
   *
   *  - Cambio de socio (SetDataBPLines) -> _recalculateDiscount = true.
   *    El descuento de cada linea debe recalcularse contra el grupo de descuento
   *    autorizado del socio nuevo, tanto para aplicarlo como para removerlo a 0.
   *
   *  - Carga de un documento para editar (SetDocumentLines) -> _recalculateDiscount = false.
   *    Solo se recalculan impuestos; el descuento guardado en SAP no se toca.
   *
   * Historial: esta regla se rompio dos veces por confundir ambos casos (CCPCC-27 rompio
   * la edicion, CCPCC-42 rompio el cambio de socio y produjo SDS-5487). Ver CCPCC-28.
   * No sustituir este parametro por una bandera de componente ni por una heuristica
   * sobre el valor de la linea: DiscountPercent siempre viene numerico y nunca es nulo.
   *
   * @param _recalculateDiscount true para recalcular el descuento del grupo del socio.
   */
  setupRecalculate(_recalculateDiscount: boolean = true): void {
    this.conta = 0;
    this.total = 0;
    this.totalUSD = 0;
    this.tax = 0;
    this.discount = 0;
    this.totalWithoutTax = 0;
    let itemsToCalculate: any[] = []; // lista de items

    this.itemsList.forEach((x) => itemsToCalculate.push(x));
    this.blockUI.start("Recalculando impuestos, espere por favor");
    setTimeout(() => {
      this.pollItemsData(itemsToCalculate, _recalculateDiscount);
    }, 1000);
  }

  /**
   * @param _recalculateDiscount ver setupRecalculate(). Se propaga en la recursion.
   */
  pollItemsData(_itemsList: any[], _recalculateDiscount: boolean = true): void {
    if (_itemsList.length === 0) {
      this.blockUI.stop();
      return;
    }
    const ITEM_INDEX = _itemsList.length - 1;
    const ITEM = _itemsList[ITEM_INDEX];

    this.itemService
      .GetItemByItemCode(
        ITEM.Item,
        this.priceList,
        this.soForm.controls.cardCode.value
      )
      .subscribe(
        (data: any) => {
          if (data.result) {
            this.total += ITEM.UnitPrice;
            const IS_VET_SERVICE = data.Item.ItemGroupCode == ITEM_GROUP_NAME.SERV_VETERINARIA;
            const HAS_RETRIVED_TAX = IS_VET_SERVICE && this.soForm.controls.PaymentMethod.value === "02"; // 02 - Targeta

            // El descuento del grupo autorizado del socio solo se aplica cuando el
            // recalculo lo dispara un cambio de socio. Al cargar un documento para
            // editar se conserva el descuento guardado en SAP. Ver setupRecalculate().
            if (_recalculateDiscount) {
              this.itemsList[ITEM_INDEX].DiscountPercent = data.Item.Discount;
            }
            this.itemsList[ITEM_INDEX].TaxCode = HAS_RETRIVED_TAX
              ? "44"
              : data.Item.TaxCode;
            this.itemsList[ITEM_INDEX].TaxRate = HAS_RETRIVED_TAX
              ? 0
              : data.Item.TaxRate;
            this.itemsList[ITEM_INDEX].U_NVT_ServicioMedico = IS_VET_SERVICE ? 1 : 0;
            this.itemsList[ITEM_INDEX].TaxCode_BCK = data.Item.TaxCode;
            this.itemsList[ITEM_INDEX].TaxRate_BCK = data.Item.TaxRate;

            this.LineTotalCalculateExt(_itemsList.length - 1);
            this.getTotals();
            _itemsList.pop();
            this.pollItemsData(_itemsList, _recalculateDiscount);
          } else {
            this.pollItemsData([]);
            this.alertService.errorAlert(
              `Error no se pudo recalcular los impuestos, motivo: Código: ${data.errorInfo.Code}, Mensaje: ${data.errorInfo.Message}`
            );
          }
        },
        (error: any) => {
          this.pollItemsData([]);
          this.alertService.errorInfoAlert(
            `Error no se pudo recalcular los impuestos, motivo: ${error}`
          );
        }
      );
  }

  /**
   * Funcion que permite llenar el select de moneda segun las monedas que posee el cliente
   * @param {string} currency Variable que contiene el tipo de moneda del cliente
   */
  getCurrencyByUser(currency: string) {
    this.currencyList = this.allCurrencyList;
    if (currency === "COL" || currency === "USD") {
      this.currencyList = this.currencyList.filter(
        (cur) => cur.Id === currency
      );
    }
    if (this.currencyList.length === 1) {
      this.soForm.patchValue({ currency: this.currencyList[0].Id });
    }
    this.SetCurr();
  }

  /**
   * Funcion para selecionar socio del typeahead
   * @param $event - Recibe como parametro el nombre cliente
   * @constructor
   */
  ChangeDescription($event: any) {
    if ($event != null) {

      let businessPartner: IBusinessPartnerModel = $event.item;
      this.businessPartnersSelect = businessPartner;
      this.isCardNameTypedByUser = false;

      $event.preventDefault();

      this.soForm.controls['cardCode'].setValue(businessPartner.CardCode);
      this.soForm.controls['cardName'].setValue(businessPartner.CardName);
      this.soForm.controls['ActividadReceptor'].setValue(businessPartner.U_ActividadReceptor);
      this.preselectTipoDocumento(businessPartner.U_ActividadReceptor);
      this.SetDataBPLines(businessPartner.CardCode);
      this.VerifyStatusMagHA(businessPartner);
    }
  }

  /**
   * Funcion para validar el cambio de nombre unicamente
   * Escribe el nombre digitado en el FormControl (unica fuente de verdad).
   * NO se muta businessPartnersSelect: ese objeto son los datos maestros del socio y
   * cualquier refresco posterior (ChangeCode, SetDefaultBP, etc.) borraba el nombre digitado.
   * @param $event - Recibe como parametro el nombre cliente
   * @constructor
   */
  ChangeOnlyText($event){
    if($event != null && !$event.item){
      this.isCardNameTypedByUser = true;
      this.soForm.controls['cardName'].setValue($event.srcElement.value, { emitEvent: false });
    }
  }

  /**
   * Resuelve el CardName que se envia a SAP.
   *
   * El valor visible en el input manda sobre el modelo: con ngbTypeahead el FormControl puede
   * quedar desincronizado de lo que el usuario ve (ver SDS-5241 / CS-48035), y el documento debe
   * salir con el nombre que el cajero tenia en pantalla al presionar el boton.
   */
  private ResolveCardNameToSend(): string {
    const domValue = this.cardNameInput && this.cardNameInput.nativeElement
      ? String(this.cardNameInput.nativeElement.value || '').trim()
      : '';

    if (domValue) return domValue;

    const controlValue = this.soForm.controls.cardName.value;

    if (typeof controlValue === 'string' && controlValue.trim()) return controlValue.trim();
    if (controlValue && controlValue.CardName) return controlValue.CardName;
    if (this.businessPartnersSelect && this.businessPartnersSelect.CardName) {
      return this.businessPartnersSelect.CardName;
    }

    return '';
  }

  // funcion para calcular los totales de la SO
  // calcula por separado los precios en dolares y colones para poder evitar inconsistencias en
  // las conversiones
  // no recibe parametros
  getTotals() {
    this.total = 0;
    this.totalUSD = 0;
    this.tax = 0;
    this.discount = 0;
    this.totalWithoutTax = 0;

    this.itemsList.forEach((element) => {
      // Aritmética entera para evitar el error de float en precios con .5 (ej: 3716.81 × 0.5)
      const lintot = Math.round(Math.round(element.UnitPrice * 100) * element.Quantity) / 100;
      const disc = Math.round((lintot * (element.DiscountPercent / 100) + Number.EPSILON) * 10000) / 10000;
      this.discount = parseFloat(Number(disc + this.discount).toString());
      const lineTotal = lintot - disc;
      this.totalWithoutTax = parseFloat(
        Number(lineTotal + this.totalWithoutTax + Number.EPSILON).toString()
      );
      this.tax = parseFloat(
        Number(lineTotal * (element.TaxRate / 100) + this.tax + Number.EPSILON).toString()
      );
    });

    // Aplicar descuento a nivel de documento si existe (se aplica sobre el subtotal antes de impuestos)
    if (this.documentLevelDiscount > 0) {
      const docDiscount = parseFloat(
        Number(this.totalWithoutTax * (this.documentLevelDiscount / 100)).toString()
      );
      this.discount = parseFloat(Number(this.discount + docDiscount).toString());
      this.totalWithoutTax = parseFloat(
        Number(this.totalWithoutTax - docDiscount).toString()
      );
      // Recalcular impuestos proporcionales después del descuento del documento
      this.tax = parseFloat(
        Number(this.totalWithoutTax * (this.tax / (this.totalWithoutTax + docDiscount))).toString()
      );
    }

    const MOBJECT = this.saleDocumentModel;

    if (MOBJECT) {
      if (MOBJECT.DocCurrency == "COL") {
        this.total += parseFloat(
          Number(this.totalWithoutTax + this.tax).toString()
        );
        this.totalUSD += parseFloat(
          Number(
            (this.totalWithoutTax + this.tax) / this.DailyExRate
          ).toString()
        );
      } else {
        this.total += parseFloat(
          Number(
            (this.totalWithoutTax + this.tax) * this.DailyExRate
          ).toString()
        );
        this.totalUSD += parseFloat(
          Number(this.totalWithoutTax + this.tax).toString()
        );
      }
    } else if (this.soForm.value.currency) {
      if (this.soForm.value.currency == "COL") {
        this.total += parseFloat(
          Number(this.totalWithoutTax + this.tax).toString()
        );
        this.totalUSD += parseFloat(
          Number(
            (this.totalWithoutTax + this.tax) / this.DailyExRate
          ).toString()
        );
      } else {
        this.total += parseFloat(
          Number(
            (this.totalWithoutTax + this.tax) * this.DailyExRate
          ).toString()
        );
        this.totalUSD += parseFloat(
          Number(this.totalWithoutTax + this.tax).toString()
        );
      }
    }

    this.total = +this.total.toFixed(2);
    this.totalUSD = +this.totalUSD.toFixed(2);
  }

  getTotalOnLoad() {
    this.total = 0;
    this.totalUSD = 0;
    this.tax = 0;
    this.discount = 0;
    this.totalWithoutTax = 0;
    this.itemsList.forEach((element) => {
      const lintot = Math.round(Math.round(element.UnitPrice * 100) * element.Quantity) / 100;
      const disc = Math.round((lintot * (element.DiscountPercent / 100) + Number.EPSILON) * 10000) / 10000;
      this.discount = parseFloat(Number(disc + this.discount).toString());
      const lineTotal = lintot - disc;
      this.totalWithoutTax = parseFloat(
        Number(lineTotal + this.totalWithoutTax + Number.EPSILON).toString()
      );
      this.tax = parseFloat(
        Number(lineTotal * (element.TaxRate / 100) + this.tax + Number.EPSILON).toString()
      );
    });

    // Aplicar descuento a nivel de documento si existe
    if (this.documentLevelDiscount > 0) {
      const docDiscount = parseFloat(
        Number(this.totalWithoutTax * (this.documentLevelDiscount / 100)).toString()
      );
      this.discount = parseFloat(Number(this.discount + docDiscount).toString());
      this.totalWithoutTax = parseFloat(
        Number(this.totalWithoutTax - docDiscount).toString()
      );
      // Recalcular impuestos proporcionales después del descuento del documento
      this.tax = parseFloat(
        Number(this.totalWithoutTax * (this.tax / (this.totalWithoutTax + docDiscount))).toString()
      );
    }
    
    if (JSON.parse(this.storage.GetCustomerData()).Currency === "COL") {
      this.total += parseFloat(
        Number(this.totalWithoutTax + this.tax).toString()
      );
      this.totalUSD += parseFloat(
        Number((this.totalWithoutTax + this.tax) / this.DailyExRate).toString()
      );
    } else {
      this.total += parseFloat(
        Number((this.totalWithoutTax + this.tax) * this.DailyExRate).toString()
      );
      this.totalUSD += parseFloat(
        Number(this.totalWithoutTax + this.tax).toString()
      );
    }

    this.total = +this.total.toFixed(2);
    this.totalUSD = +this.totalUSD.toFixed(2);
  }

  // funcion al cambiar el tipo de taxcode
  // recibe como parametro el taxxode y el indice de la lista
  changeTaxCode(i: number, item: any) {
    const rate = this.taxesList.find(
      (i) => i.TaxCode === item.TaxCode.toUpperCase()
    );
    
    const idx: number = this.itemsList.indexOf(
      this.itemsList.find((x) => x.ItemCode == item.ItemCode)
    );

    if (typeof rate !== "undefined") {
      this.itemsList[idx].TaxRate = parseFloat(
        this.decimalPipe.transform(rate.TaxRate, ".2")
      );
      this.itemsList[idx].TaxCode = rate.TaxCode.toUpperCase();
      this.LineTotalCalculate(idx);
    }
  }

  // funcion para calcular el total de la linea
  // recibe como parametro el index de la lista de items
  LineTotalCalculate(idx: number) {
    if (!this.maxDiscuont) this.maxDiscuont = 10;
    if (
      !this.itemsList[idx].DiscountPercent ||
      this.itemsList[idx].DiscountPercent < 0
    )
      this.itemsList[idx].DiscountPercent = 0;

    if (this.itemsList[idx].DiscountPercent > this.maxDiscuont) {
      this.alertService.infoInfoAlert(
        "El descuento no puede ser mayor a " +
        this.maxDiscuont +
        "% que es lo permitido para este usuario"
      );
      this.itemsList[idx].DiscountPercent = this.maxDiscuont;
    }

    const qty = this.itemsList[idx].Quantity;
    const price = this.itemsList[idx].UnitPrice;
    let lineTotal = Number((qty * price).toString());
    const taxamount = Number(
      (lineTotal * (this.itemsList[idx].TaxRate / 100)).toString()
    );
    lineTotal = Number((lineTotal + taxamount).toString());
    lineTotal = Number(
      (
        lineTotal -
        lineTotal * (this.itemsList[idx].DiscountPercent / 100)
      ).toString()
    );
    this.itemsList[idx].LinTot = lineTotal;
    this.getTotals();
  }

  LineTotalCalculateExt(idx: number) {
    let disc = 0;
    if (this.itemsList[idx].DiscountPercent <= this.maxDiscuont) {
      disc = this.itemsList[idx].DiscountPercent;
    } else {
      disc = this.maxDiscuont;
      this.alertService.infoInfoAlert(
        "El descuento no puede ser mayor a " +
        this.maxDiscuont +
        " que es lo permitido para este usuario"
      );
      this.itemsList[idx].DiscountPercent = this.maxDiscuont;
    }
    if (this.itemsList[idx].DiscountPercent == null) {
      this.itemsList[idx].DiscountPercent = 0;
    }

    const qty = this.itemsList[idx].Quantity;
    const price = this.itemsList[idx].UnitPrice;
    let lineTotal = Number((qty * price).toFixed(2));
    const taxamount = Number(
      (lineTotal * (this.itemsList[idx].TaxRate / 100)).toFixed(2)
    );
    lineTotal = Number((lineTotal + taxamount).toFixed(2));
    lineTotal = Number((lineTotal - lineTotal * (disc / 100)).toFixed(2));
    this.itemsList[idx].LinTot = lineTotal;
    this.getTotals();
    this.isEditingPrice = false;
  }

  togglePriceEdition(): void {
    this.isEditingPrice = true;
    console.log("click");
  }

  // funcion que se llama desde la ui para hacer la impresion de la orden de venta
  printSO() {
    this.printSaleOrder(this.lastSO);
  }

  // funcion para imprimir la factura
  printSaleOrder(DocEntry: number) {
    this.blockUI.start("Generando la impresión..."); // Start blocking
    this.reportsService.printReport(DocEntry, ReportType.SaleOrder).subscribe(
      (data: any) => {
        this.blockUI.stop(); // Stop blocking
        printJS({
          printable: data,
          type: "pdf",
          base64: true,
        });
      },
      (error) => {
        this.blockUI.stop();
        this.alertService.errorInfoAlert(
          `Error al generar el reporte, Error: ${error}`
        );
      }
    );
  }
  openModal(content) {
    this.modalReference = this.modalService.open(content, {
      ariaLabelledBy: "modal-basic-title",
      size: "lg",
    });
    this.modalReference.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
  // llena los campos de la tabla de items con los campos parametriados
  GetParamsViewList() {
    this.blockUI.start("Procesando parametrizaciones, espere por favor..."); // Start blocking
    this.paramsService.getParasmView().subscribe(
      (data: any) => {
        this.blockUI.stop();
        if (data.result) {
          this.viewParamList = data.Params.filter((param) => {
            return param.type === 1 && param.Visibility;
          });

          this.viewParamList.splice(7, 0, {
            CompanyId: 4,
            Descrip: "Precio unitario con impuesto",
            Display: true,
            Id: 144,
            Name: "UPWT",
            Order: 15,
            ParamsId: 11,
            Text: "Precio+Imp",
            ViewsId: 1,
            Visibility: true,
            type: 1,
          });

          this.tableLength = 0;
          for (var i = 0; i < this.viewParamList.length; i++) {
            this.tableLength += this.MapWidth[this.viewParamList[i].Name];
          }
          this.viewParamListHeader = data.Params.filter((param) => {
            return param.type === 2;
          });
          this.viewParamListTotales = data.Params.filter((param) => {
            return param.type === 3;
          });
          this.viewParamTitles = data.Params.filter((param) => {
            return param.type === 6;
          });
          this.ChargeParamstoView();
        } else {
          this.alertService.errorAlert(
            "Error al cargar los parámetros de la página - " +
            data.errorInfo.Message
          );
        }
      },
      (error) => {
        this.blockUI.stop();
        this.alertService.errorInfoAlert(
          `Error al intentar conectar con el servidor, Error: ${error}`
        );
      }
    );
  }
  // funcion para obtener la información de los disponibles de un item en los almacenes
  // recibe como parametros el item y el index
  GetWHAvailableItem(event, content, ItemCode, idx) {
    if (ItemCode !== "") {
      if (event.type === "dblclick") {
        this.blockUI.start(
          "Obteniendo Disponibilidad del Artículo, Espere Por Favor..."
        ); // Start blocking
        this.itemService.GetWHAvailableItem(ItemCode).subscribe(
          (data: any) => {
            if (data.result) {
              this.WHAvailableItemList.length = 0;
              this.itemCode = ItemCode;
              this.indexAvaItem = idx;
              this.WHAvailableItemList = data.whInfo;
              if (data.whInfo.length > 0) {
                this.expandedIndex = -1;
                (<HTMLButtonElement>(
                  document.getElementById("triggerWhsPreview")
                )).click();
              } else {
                this.alertService.errorInfoAlert(
                  "Este artículo no está disponibles en ningún almacén."
                );
              }
            } else {
              this.alertService.errorAlert(
                "Error al obtener Items del almacén - Error: " +
                data.errorInfo.Message
              );
            }
            this.blockUI.stop(); // Stop blocking
          },
          (error: any) => {
            this.blockUI.stop(); // Stop blocking
            this.alertService.errorInfoAlert(
              `Error al intentar conectar con el servidor, Error: ${error}`
            );
          }
        );
      }
    }
  }

  // funcion para seleccionar un almacen nuevo para el item a facturar
  avaItemSelected(event, avaItem, idx: number) {
    if (event.type === "dblclick") {
      this.itemsList[this.indexAvaItem].WarehouseCode = avaItem.WhsCode;
      this.itemsList[this.indexAvaItem].WhsName = avaItem.WhsName;
      this.itemsList[this.indexAvaItem].Serie = "";
      this.itemsList[this.indexAvaItem].SysNumber = 0;
      (<HTMLButtonElement>document.getElementById("triggerWhsClose")).click();
    }
  }

  // funcion para cerrar la modal para escoger la terminal y sucursal
  close() {
    this.modalReference.close();
  }

  // funcion para selecccionar una seria
  // recibe como parametro el objeto de serie y del almacen en el que se selecciono la serie
  selectSerie(series, avaItem) {
    const idx: number = this.itemsList.indexOf(
      this.itemsList.find((x) => x.ItemCode == this.itemCode)
    );
    if (series.Disponible > 0) {
      this.itemsList[this.indexAvaItem].Serie = series.PlacaChasis;
      this.itemsList[this.indexAvaItem].SysNumber = series.SysNumber;
      this.itemsList[this.indexAvaItem].WarehouseCode = avaItem.WhsCode;
      this.itemsList[this.indexAvaItem].WhsName = avaItem.WhsName;
      this.itemsList[this.indexAvaItem].UnitPrice = series.Precio;
      this.LineTotalCalculateExt(idx);
      this.alertService.infoInfoAlert(
        `Se seleccionó la serie: ${series.PlacaChasis}`
      );
    } else {
      this.alertService.infoInfoAlert(
        "No puede seleccionar esta serie ya que no posee disponibles"
      );
    }
  }

  // Carga los datos parametrizados en las variables
  ChargeParamstoView() {
    // parametrizaciones para dtos de cabezera
    this.viewParamListHeader.forEach((element) => {
      if (element.Name === "lbCardCode") {
        this.lbCardCode = element;
      }
      if (element.Name === "txtCardCode") {
        this.txtCardCode = element;
      }
      if (element.Name === "lbCardName") {
        this.lbCardName = element;
      }
      if (element.Name === "txtCardName") {
        this.txtCardName = element;
      }
      if (element.Name === "lbCurrency") {
        this.lbCurrency = element;
      }
      if (element.Name === "txtCurrency") {
        this.txtCurrency = element;
      }
      if (element.Name === "txtPayTerms") {
        this.txtPayTerms = element;
      }
      if (element.Name === "lbPayTerms") {
        this.lbPayTerms = element;
      }
      if (element.Name === "txtPriceList") {
        this.txtPriceList = element;
      }
      if (element.Name === "lbPriceList") {
        this.lbPriceList = element;
      }
      if (element.Name === "txtComments") {
        this.txtComments = element;
      }
      if (element.Name === "lbComments") {
        this.lbComments = element;
      }
      if (element.Name === "txtSLP") {
        this.txtSLP = element;
      }
      if (element.Name === "lbSLP") {
        this.lbSLP = element;
      }
    });

    // parametrizaciones datos de totales
    this.viewParamListTotales.forEach((element) => {
      if (element.Name === "lbTotalExe") {
        this.lbTotalExe = element;
      }
      if (element.Name === "txtTotalExe") {
        this.txtTotalExe = element;
      }
      if (element.Name === "lbDiscount") {
        this.lbDiscount = element;
      }
      if (element.Name === "txtDiscount") {
        this.txtDiscount = element;
      }
      if (element.Name === "lbTaxes") {
        this.lbTaxes = element;
      }
      if (element.Name === "txtTaxes") {
        this.txtTaxes = element;
      }
      if (element.Name === "lbTotal") {
        this.lbTotal = element;
      }
      if (element.Name === "txtTotal") {
        this.txtTotal = element;
      }
    });

    // parametrizacion del titulo
    let obj = this.viewParamTitles.filter((param) => {
      return param.Name === "T_so";
    });
    this.title = obj[0].Text;
  }

  // Obtiene los tipos de monedas ya sea Col o Usd desde una vista SQL
  GetCurrencyType() {
    this.blockUI.start("Procesando monedas, espere por favor..."); // Start blocking
    this.paramsService.GetCurrencyType().subscribe(
      (data: any) => {
        if (data.length > 0) {
          this.currencyList = data;
          this.allCurrencyList = data;
          this.DefaultConfigurationBusinessPartner();
          this.blockUI.stop();
        } else {
          this.blockUI.stop();
          this.alertService.errorAlert(
            "Error al cargar las monedas - " + data.errorInfo.Message
          );
        }
      },
      (error) => {
        this.blockUI.stop();
        this.alertService.errorInfoAlert(
          `Error al intentar conectar con el servidor, Error: ${error}`
        );
      }
    );
  }

  // Retorna el simbolo de la moneda al elegir en el dropdown la moneda
  SetCurr() {
    let cur = this.currencyList.find(
      (curr) => curr.Id === this.soForm.controls.currency.value
    );

    if (this.storage.GetDocEntry() > 0) {
      cur = this.currencyList.find(
        (curr) => {
          let stringCustomerData = this.storage.GetCustomerData();
          if(stringCustomerData){
            return curr.Id === JSON.parse(stringCustomerData).Currency;
          } else {
           return false;
          }
        }
      );
    }

    if (!cur) return;
    this.setCurr = cur.Symbol;
  }
  CleanFields(): void {
    this.soForm.controls["cardName"].enable();
    this.soForm.controls["cardCode"].enable();
    this.commonService.hasDocument.next(``);
    this.storage.SaveBreadCrum(``);
    if (this.typeArrow)
      (<HTMLButtonElement>(
        document.getElementById("triggerFECollapser")
      )).click();
    this.storage.SaveDocEntry(-1);
    this.storage.SaveUIAction(-1);

    this.OnLoad();
  }

  /**
   * Clear lists and reload data for OS
   * @constructor
   */
  CreateNew() {
    this.commonService.hasDocument.next(``);
    this.storage.SaveBreadCrum(``);
    if (this.typeArrow)
      (<HTMLButtonElement>(
        document.getElementById("triggerFECollapser")
      )).click();
    this.storage.SaveDocEntry(-1);
    this.storage.SaveUIAction(-1);


    this.IndexMinDocument = 0 ;
    this.IndexMaxUpdate = 0;
    this.showBtnBPContacs = false;
    this.isOrderFromLink = false;
    this.canAuthorize = false;
    this.UdfsInDocument = [];
    this.UdfsInDocument = this.GetDocumentUDFs();
    this.isDocumentSubmitted = false;
    this.lastSO = 0;
    this.documentLevelDiscount = 0; // Reiniciar descuento a nivel de documento
    this.DEFAULT_BUSINESS_PARTNER =
      this.storage.getBranchOffice().CashBusinessPartnerCode;
    this.generateUniqueInvoiceId();
    this.isSalesManSelected = true;
    this.hasIdentification = false;
    this.isRequiredEmail = false;
    this.isOnPrint = false;
    this.InvalidCardName = false;
    this.commonService.hasDocument.next(``);
    this.storage.SaveBreadCrum(``);
    if (this.typeArrow)
      (<HTMLButtonElement>(
        document.getElementById("triggerFECollapser")
      )).click();
    this.storage.SaveDocEntry(-1);
    this.storage.SaveUIAction(-1);
    this.onSubmitButtonPrefix = "Crear órden de venta";
    this.btnVisibleBool = true;
    this.isCashCustomer = false;
    this.isOnCreation = true;
    this.correctSO = false;
    this.isEditingPrice = false;
    this.saleDocumentModel = null;
    this.soForm.reset();
    this.feForm.reset();
    this.itemsList.length = 0;
    this.overdueBalances = [];
    this.cantonId = "0";
    this.districtId = "0";
    this.Cant.setValue(1);
    this.neighborhoodId = "0";
    this.provinceId = "0";
    this.getTaxes();
    this.getTotals();
    this.soForm.patchValue({ currency: this.currencyList[0].Id });
    this.total = 0;
    this.totalUSD = 0;
    this.btnVisibleBool = true;
    this.conta = 0;
    this.total = 0;
    this.totalUSD = 0;
    this.tax = 0;
    this.discount = 0;
    this.totalWithoutTax = 0;
    this.DailyExRate = 0;
    this.provinceId = "0";
    this.cantonId = "0";
    this.districtId = "0";
    this.neighborhoodId = "0";
    this.soForm.controls["cardName"].enable();
    this.soForm.controls["cardCode"].enable();
    this.ItemInfo.setValue("");
    this.soForm = this.fb.group({
      cardCode: [this.DEFAULT_BUSINESS_PARTNER, Validators.required],
      cardName: [""],
      currency: ["", Validators.required],
      PayTerms: ["0"],
      SlpList: ["", Validators.required],
      BillOverdue: ["1", Validators.required],
      PaymentMethod: ["01", Validators.required],
      ActividadReceptor: [""],
      CondicionVenta: ["", Validators.required],
      CondicionVentaOtros: [""],
      Comment: "",
      NumAtCard: "",
      Discount: [0],
      tipoDocumento: ["TE"],
    });

    // ChangeCode se invoca DESPUES de reconstruir soForm: dispara una consulta asincrona del socio
    // de Contado por defecto y su respuesta debe caer sobre el formulario ya vigente.
    this.isCardNameTypedByUser = false;
    if (this.cardNameInput && this.cardNameInput.nativeElement) {
      this.cardNameInput.nativeElement.value = "";
    }
    this.ChangeCode(this.DEFAULT_BUSINESS_PARTNER);

    this.identificationTypeList = IdentificationType;
    this.getProvinces();
    this.getExRate();
    this.createFEForm();
    this.getMaxDiscout();
    this.SetDefaultBP();
    this.GetParamsViewList();
    this.GetPriceList();
    this.GetSalesPersonList();
    this.GetPayTerms();
    this.nameField.nativeElement.focus();
  }

  // obtiene los terminos de pago
  GetPayTerms() {
    this.blockUI.start("Obteniendo Terminos de pago, Espere Por Favor..."); // Start blocking
    this.itemService.GetPayTerms().subscribe(
      (data: any) => {
        if (data.result) {
          this.PayTermsList = data.payTermsList;
          this.blockUI.stop(); // Stop blocking
        } else {
          this.blockUI.stop(); // Stop blocking
          this.alertService.errorAlert(
            `Error: Código: ${data.errorInfo.Code}, Mensaje: ${data.errorInfo.Message}`
          );
        }
      },
      (error: any) => {
        this.blockUI.stop(); // Stop blocking
        this.alertService.errorInfoAlert(
          `Error al intentar conectar con el servidor, Error: ${error}`
        );
      }
    );
  }
  // obtiene la lista de pago
  GetPriceList() {
    this.blockUI.start("Obteniendo Listas de precios, Espere Por Favor..."); // Start blocking
    this.itemService.GetPriceList().subscribe(
      (data: any) => {
        if (data.result) {
          this.PriceList = data.priceList;
          this.soForm.patchValue({ PriceList: this.PriceList[0].ListNum });

          this.blockUI.stop(); // Stop blocking
        } else {
          this.blockUI.stop(); // Stop blocking
          this.alertService.errorAlert(
            `Error: Código: ${data.errorInfo.Code}, Mensaje: ${data.errorInfo.Message}`
          );
        }
      },
      (error: any) => {
        this.blockUI.stop(); // Stop blocking
        this.alertService.errorInfoAlert(
          `Error al intentar conectar con el servidor, Error: ${error}`
        );
      }
    );
  }

  // obtiene la lista de personas vendedoras
  GetSalesPersonList() {
    this.blockUI.start("Obteniendo vendedores, Espere Por Favor..."); // Start blocking
    this.smService.getSalesMan().subscribe(
      (data: any) => {
        if (data.result) {
          if (data.salesManList.length > 0) {
            this.slpTypeaheadList = [];
            data.salesManList.forEach(element => {
              this.slpTypeaheadList.push({
                SlpCode: element.SlpCode,
                SlpName: element.SlpName,
                TypeAheadFormatt: `${element.SlpCode} ${element.SlpName}`
              });
            });
          }
          const DOC_ENTRY = this.storage.GetDocEntry();
          if (DOC_ENTRY > 0) {

            const CUSTOMER_DATA = JSON.parse(this.storage.GetCustomerData());

            if (CUSTOMER_DATA && !(Object.keys(CUSTOMER_DATA).length === 0)) {
              const SLP = this.slpTypeaheadList.find(x => x.SlpCode === CUSTOMER_DATA.SlpCode.toString());

              if (SLP) {
                this.soForm.patchValue({ SlpList: SLP });
              }
            }
          } else {
            const SLP = this.slpTypeaheadList.find(x => x.SlpCode === this.defaultSlpCode.toString());

            if (SLP) {
              this.soForm.patchValue({ SlpList: SLP });
            }
          }

          this.blockUI.stop(); // Stop blocking
        } else {
          this.blockUI.stop(); // Stop blocking
          this.alertService.errorAlert(
            `Error: Código: ${data.errorInfo.Code}, Mensaje: ${data.errorInfo.Message}`
          );
        }
      },
      (error: any) => {
        this.blockUI.stop(); // Stop blocking
        this.alertService.errorInfoAlert(
          `Error al intentar conectar con el servidor, Error: ${error}`
        );
      }
    );
  }

  ClearItemList() {
    this.itemsList.length = 0;
  }

  //chequea si hay existencias del item a agregar
  CheckAvailableItem(ItemCode) {
    if (ItemCode !== "") {
      this.blockUI.start(
        "Obteniendo Disponibilidad del Artículo, Espere Por Favor..."
      ); // Start blocking
      this.itemService.GetWHAvailableItem(ItemCode).subscribe(
        (data: any) => {
          if (data.result) {
            this.WHAvailableItemList.length = 0;
            this.itemCode = ItemCode;
            this.WHAvailableItemList = data.whInfo;
            if (data.whInfo.length <= 0) {
              this.blockUI.stop(); // Stop blocking
              this.alertService.infoInfoAlert(
                "Este artículo no posee disponibles en ningún almacén."
              );
            }
            this.blockUI.stop(); // Stop blocking
          } else {
            this.blockUI.stop(); // Stop blocking
            this.alertService.errorAlert(
              "Error al Obtener disponibilidad el artículo - " +
              data.errorInfo.Message
            );
          }
        },
        (error: any) => {
          this.blockUI.stop(); // Stop blocking
          this.alertService.errorInfoAlert(
            `Error al intentar conectar con el servidor, Error: ${error}`
          );
        }
      );
    }
  }
  // agrega un item a la lista
  addItems(item) {
    if (this.ItemInfo.value !== "") {
      let mobileNavigatorObject: any = window.navigator;
      if (mobileNavigatorObject && mobileNavigatorObject.clipboard) {
        mobileNavigatorObject.clipboard
          .readText()
          .then((text) => {
            if (!isNaN(parseInt(text))) {
              if (Number(text) > this.maxWeightTo0) {
                mobileNavigatorObject.clipboard
                  .writeText("*")
                  .then((text) => {})
                  .catch((err) => {});
              }
            }

            if (this.correctSO) {
              this.ItemInfo.setValue("");
              this.alertService.infoInfoAlert(
                `Presione el boton limpiar para poder agregar productos a la orden`
              );
              return;
            }
            let cant = Number(this.Cant.value);

            let code = item.item.split(" COD. ")[0];
            let searchitem = true;
            this.blockUI.start(
              "Obteniendo Información del Artículo, Espere Por Favor..."
            ); // Start blocking

            var index: number = this.itemsList.indexOf(
              this.itemsList.find((x) => x.Item == code)
            );

            if (index != -1) {
              this.itemsList[index].Quantity += cant;
              this.itemsList[index].LinTot =
                this.itemsList[index].Quantity *
                this.itemsList[index].UnitPrice;
              searchitem = false;
              this.LineTotalCalculateExt(index);
              this.getTotals();
              this.blockUI.stop();
            }

            this.itemService
              .GetItemByItemCode(
                item.item.split(" COD. ")[0],
                this.priceList,
                this.soForm.controls.cardCode.value
              ) // GETITEMINFO
              .subscribe(
                (data: any) => {
                  if (data.result) {
                    if (searchitem) {
                      this.conta++;
                      this.total += data.Item.UnitPrice;
                      const IS_VET_SERVICE = data.Item.ItemGroupCode == ITEM_GROUP_NAME.SERV_VETERINARIA;
                      const HAS_RETRIVED_TAX = IS_VET_SERVICE && this.soForm.controls.PaymentMethod.value === "02"; // 02 - Targeta
                      let tot =
                        this.soForm.get("currency").value === "COL"
                          ? data.Item.UnitPrice * cant
                          : cant *
                          parseFloat(
                            Number(
                              data.Item.UnitPrice / this.DailyExRate
                            ).toFixed(2)
                          );
                      let itemAux = {
                        Item: data.Item.ItemCode,
                        ItemCode: `${data.Item.ItemCode} - ${data.Item.ItemName}`,
                        ItemName: `${data.Item.ItemName}`,
                        CodeName: `${data.Item.ItemCode} - ${data.Item.ItemName}`,
                        UnitPrice:
                          this.soForm.get("currency").value === "COL"
                            ? data.Item.UnitPrice
                            : parseFloat(
                              Number(
                                data.Item.UnitPrice / this.DailyExRate
                              ).toFixed(2)
                            ),
                        UnitPriceCol: data.Item.UnitPrice,
                        UnitPriceDol: parseFloat(
                          Number(
                            data.Item.UnitPrice / this.DailyExRate
                          ).toFixed(2)
                        ),
                        U_SugPrice: 0,
                        TaxCode: HAS_RETRIVED_TAX ? "44" : data.Item.TaxCode, // 44 Iva devuelto codigo
                        TaxRate: HAS_RETRIVED_TAX ? 0 : data.Item.TaxRate, // 0 Iva devualto valor
                        TaxCode_BCK: data.Item.TaxCode,
                        TaxRate_BCK: data.Item.TaxRate,
                        ItemGroupCode: data.Item.ItemGroupCode,
                        Quantity: cant,
                        Active: true,
                        Id: this.conta,
                        LinTot: tot,
                        DiscountPercent: data.Item.Discount,
                        WarehouseCode: this.whCode,
                        WhsName: this.whName,
                        Serie: "",
                        SysNumber: 0,
                        OnHand: data.Item.OnHand,
                        U_NVT_ServicioMedico: IS_VET_SERVICE ? 1 : 0,
                        InvntItem: data.Item.InvntItem,
                        LineStatus: "O",
                        LineNum: -1
                      } as IDocumentLine;

                      this.itemsList.unshift(itemAux);
                      this.LineTotalCalculateExt(0);
                      this.getTotals();
                    }
                    this.Cant.setValue(1);
                    this.ItemInfo.setValue("");

                    if (data.Item.InvntItem === "Y" && data.Item.OnHand <= 0) {
                      this.itemsList[0].Quantity = 0;
                      this.itemsList[0].LinTot = 0;
                      searchitem = false;
                      this.LineTotalCalculate(0);
                      this.getTotals();
                    }
                  } else {
                    this.alertService.errorAlert(
                      `Error: no se pudo obtener la información del item solicitado: Código: ${data.errorInfo.Code}, Mensaje: ${data.errorInfo.Message}`
                    );
                  }
                  this.blockUI.stop(); // Stop blocking
                },
                (error: any) => {
                  this.blockUI.stop(); // Stop blocking
                  this.alertService.errorInfoAlert(
                    `Error al intentar conectar con el servidor, Error: ${error}`
                  );
                }
              );
          })
          .catch((err) => {});
      }
    }
  }
  cantChange() {
    if (this.Cant.value < 1) {
      this.Cant.setValue(1);
    }
  }

  identificationTypeChange(IdentificationValue: string) {
    switch (IdentificationValue) {
      case "00": {
        this.feForm.controls["Identification"].setValidators([]);
        this.feForm.controls["Identification"].updateValueAndValidity();
        this.feForm.controls["Email"].setValidators([]);
        this.feForm.controls["Email"].updateValueAndValidity();
        this.neighborhoodList.length = 0;
        this.districtList.length = 0;
        this.cantonList.length = 0;
        this.provinceList.length = 0;
        break;
      }
      case "01": {
        this.validatorFeForm(9, 9);
        break;
      }
      case "02":
      case "04": {
        this.validatorFeForm(10, 10);
        break;
      }
      case "03": {
        this.validatorFeForm(11, 12);
        break;
      }
    }
  }

  validatorFeForm(min: number, max: number) {
    this.feForm.controls["Identification"].setValidators([
      Validators.required,
      Validators.minLength(min),
      Validators.maxLength(max),
    ]);
    this.feForm.controls["Identification"].updateValueAndValidity();
    this.feForm.controls["Email"].setValidators([
      Validators.required,
      Validators.minLength(2),
      Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$"),
    ]);
    this.feForm.controls["Email"].updateValueAndValidity();
  }

  getProvinces() {
    this.jsonDataService.getJSONProvinces().subscribe((data: any) => {
      this.provinceList = data.Provinces;
      this.feForm.patchValue({ Provincia: this.provinceList[0].ProvinceId });
      this.getCantons(this.provinceList[0].ProvinceId);
    });
  }

  getCantons(provinceId) {
    this.provinceId = provinceId;
    this.jsonDataService.getJSONCountryPlaces().subscribe((data: any) => {
      this.cantonList = this.unique(
        data.Country.filter((x) => x.ProvinceId === this.provinceId),
        "CantonId"
      );
      if (typeof this.feForm.value.Canton !== "undefined") {
        if (this.provinceId === "0") {
          this.feForm.patchValue({ Canton: this.cantonList[0].CantonId });
        } else {
          this.feForm.patchValue({ Canton: this.cantonId });
        }
      }
    });
  }

  getDistrics(cantonId) {
    this.cantonId = cantonId;
    this.jsonDataService.getJSONCountryPlaces().subscribe((data: any) => {
      this.districtList = this.unique(
        data.Country.filter(
          (x) =>
            x.ProvinceId === this.provinceId && x.CantonId === this.cantonId
        ),
        "DistrictId"
      );
      if (typeof this.feForm.value.Distritos !== "undefined") {
        if (this.provinceId === "0") {
          this.feForm.patchValue({
            Distritos: this.districtList[0].DistrictId,
          });
        } else {
          this.feForm.patchValue({ Distritos: this.districtId });
        }
      }
    });
  }

  getNeighborhood(districtId) {
    this.districtId = districtId;
    this.jsonDataService.getJSONCountryPlaces().subscribe((data: any) => {
      this.neighborhoodList = this.unique(
        data.Country.filter(
          (x) =>
            x.ProvinceId === this.provinceId &&
            x.CantonId === this.cantonId &&
            x.DistrictId === this.districtId
        ),
        "NeighborhoodId"
      );
      if (typeof this.feForm.value.Barrio !== "undefined") {
        if (this.neighborhoodId === "0") {
          this.feForm.patchValue({
            Barrio: this.neighborhoodList[0].neighborhoodId,
          });
        } else {
          this.feForm.patchValue({ Barrio: this.neighborhoodId });
        }
      }
    });
  }

  /**
   * Sets the default values
   * @constructor
   */
  DefaultConfigurationBusinessPartner() {

    const MOBJECT = this.saleDocumentModel;

    if(MOBJECT){
      this.getCurrencyByUser(MOBJECT.DocCurrency);
      this.soForm.patchValue({ cardName: MOBJECT.CardName });
      this.bpService.GetBussinesPartnerByCardCode(MOBJECT.CardCode)
        .pipe()
        .subscribe(
          (bp) => {
            if(bp!=null){
              this.priceList = bp.BusinessPartnerModel.ListNum;
            }
          },
          err => {console.log(err);}
        )

    }else{
      let customer = this.businessPartnerDefault;
      if(customer){
        this.getCurrencyByUser(customer.Currency);

        this.soForm.patchValue({ cardName: customer.CardName });
        this.priceList = customer.ListNum;
      }

    }

  }

  unique(array, propertyName) {
    return array.filter(
      (e, i) =>
        array.findIndex((a) => a[propertyName] === e[propertyName]) === i
    );
  }

  getCompanies() {
    this.blockUI.start("Obteniendo Compañías, Espere Por Favor..."); // Start blocking
    this.companyService.GetCompanies().subscribe(
      (data: any) => {
        if (data.result) {
          this.companiesList.length = 0;
          this.companiesList = data.companiesList;
          this.companiesList.forEach((comp) => {
            this.pesoBolsa = comp.ScaleWeightToSubstract;
            this.priceEditable = comp.IsLinePriceEditable;
            this.maxWeightTo0 = comp.ScaleMaxWeightToTreatAsZero;
          });
        } else {
          this.alertService.errorAlert(
            "Error al cargar compañías - Error: " + data.errorInfo.Message
          );
        }
        this.blockUI.stop(); // Stop blocking
      },
      (error: any) => {
        this.blockUI.stop(); // Stop blocking
        this.alertService.errorInfoAlert(
          `Error al intentar conectar con el servidor, Error: ${error}`
        );
      }
    );
  }

  setWarehouseInfo() {
    let session = this.storage.getSession(navigator.onLine);
    if (session) {
      session = JSON.parse(session);

      this.whCode = session.WhCode;
      this.whName = session.WhName;
    }
  }

  /**
   * Load initial data
   * @constructor
   * @private
   */
  private SetInitialData():void {
    if (this.permisos) {
      this.nameField.nativeElement.focus();
    }

    this.DEFAULT_BUSINESS_PARTNER = this.storage.getBranchOffice().CashBusinessPartnerCode;

    if (this.DOC_ENTRY <= 0) {
    this.storage.SaveUIAction(-1);
    this.isOnCreation = true;
    }

    const selectedSLP = this.slpTypeaheadList.find(x => x.SlpCode === this.defaultSlpCode.toString());

    if (selectedSLP) {
      this.soForm.patchValue({ SlpList: selectedSLP });
    }


    let customer = this.businessPartnersSelect;
    if (customer) {

      this.soForm.patchValue({
        cardCode: this.DEFAULT_BUSINESS_PARTNER,
        cardName: customer.CardName
      });

      this.priceList = customer.ListNum;
      this.isCashCustomer = customer.QryGroup1 === "Y";

      this.getCurrencyByUser(customer.Currency);

    }


  }

  /**
   * Set initial document
   * @constructor
   * @private
   */
  private SetDocument():void {

    let CustomerData: string = JSON.stringify({
      CardCode: this.saleDocumentModel.CardCode,
      Currency: this.saleDocumentModel.DocCurrency,
      SlpCode: this.saleDocumentModel.SalesPersonCode,
    });

    this.storageService.SaveCustomerData(CustomerData);
    this.DEFAULT_BUSINESS_PARTNER = this.saleDocumentModel.CardCode;

    // Preservar el descuento a nivel de documento desde SAP
    this.documentLevelDiscount = this.saleDocumentModel.DiscountPercent || 0;


    //#region Autorizacion orden venta
    let estadoOv = this.saleDocumentModel.U_EstadoOV;

    if (this.isOrderFromLink) {

      let msg: string = '';

      if (estadoOv == "02") {
        if (!this.isPermAutorizeSale)
          msg = "No cuenta con los permisos para realizar esta acción.";
      } else {
        msg = "El acceso a esta orden de venta no esta permitido.";
      }

      if (msg != '') {
        this.alertService.errorAlert(
          msg
        );
        this.router.navigate(["/home"]);
      }

      this.commonService.hasDocument.next(`Documento número ${this.saleDocumentModel.DocNum}`);
      this.storageService.SaveBreadCrum(`Documento número ${this.saleDocumentModel.DocNum}`);


    }

    if (estadoOv != null) {
      this.canAuthorize = estadoOv == "02" && this.isPermAutorizeSale;
      this.autForm.patchValue({ Estado: estadoOv });
    }
    //endregion

    //#region DocumentForm
    const selectedSLP = this.slpTypeaheadList.find(
      x => x.SlpCode === this.saleDocumentModel.SalesPersonCode.toString()
    );

    this.soForm.patchValue({
      SlpList: selectedSLP ? selectedSLP : "",
      cardCode: this.saleDocumentModel.CardCode,
      // Mandan los datos del documento, no los del socio: en socios de Contado el nombre del
      // documento es el que digito el cajero y debe conservarse al editar/actualizar.
      cardName: this.saleDocumentModel.CardName
        || (this.businessPartnersSelect ? this.businessPartnersSelect.CardName : ""),
      Comment: this.saleDocumentModel.Comments,
      currency: this.saleDocumentModel.DocCurrency,
    });

    if(Number(localStorage.getItem("SOAndSQAction")) !== SOAndSQActions.CopyToOrder){
      this.soForm.patchValue({
        BillOverdue: this.saleDocumentModel.U_FacturaVencida === "SI" ? "0" : "1",
        PayTerms: this.saleDocumentModel.U_Facturacion === "Contado" ? "0" : "1",
        PaymentMethod: this.saleDocumentModel.U_NVT_Medio_Pago,
        NumAtCard: this.saleDocumentModel.NumAtCard === "0" ? "" : this.saleDocumentModel.NumAtCard,
        ActividadReceptor: this.saleDocumentModel.U_ActividadReceptor,
        CondicionVenta: this.saleDocumentModel.U_CondicionVenta,
        CondicionVentaOtros: this.saleDocumentModel.U_CondicionVentaOtros,
        tipoDocumento: this.saleDocumentModel.U_TipoDocE || 'TE'
      });
    }
    //endregion

    // Usar businessPartnersSelect solo si está disponible Y coincide con el CardCode del documento
    // Esto previene usar un cliente incorrecto cuando businessPartnersSelect no está sincronizado
    const customer = this.businessPartnersSelect;

    if (customer && customer.CardCode === this.saleDocumentModel.CardCode) {
      this.priceList = customer.ListNum;
      this.getCurrencyByUser(customer.Currency);
      this.isCashCustomer = customer.QryGroup1 === "Y";
    } else {
      // Si businessPartnersSelect no coincide con el documento, no establecer priceList aquí
      // Se establecerá cuando se cargue el cliente correcto
      const bpCardCode = customer ? customer.CardCode : 'null';
    }

    if (Number(localStorage.getItem("SOAndSQAction")) !== SOAndSQActions.CopyToOrder && this.saleDocumentModel.U_NumIdentFE) {

      this.feForm.patchValue({
        IdType: this.saleDocumentModel.U_TipoIdentificacion,
        Identification: this.saleDocumentModel.U_NumIdentFE,
        Email: this.saleDocumentModel.U_CorreoFE,
        ObservacionFE: this.saleDocumentModel.U_ObservacionFE,
      });

      if (this.isCashCustomer) {
        (<HTMLButtonElement>(
          document.getElementById("triggerFECollapser")
        )).click();
      }
    }

  }

  private SetDocumentBaseLines(): void{

    this.saleDocumentModel.DocumentLines.forEach((x) => {
      this.conta++;
      const tot = x.UnitPrice * x.Quantity;
      let itemAux = {
        Item: `${x.ItemCode}`,
        ItemCode: `${x.ItemCode} - ${x.ItemCode}`,
        ItemName: `${x.ItemName}`,
        CodeName: `${x.ItemCode} - ${x.ItemName}`,
        UnitPrice:
          JSON.parse(this.storage.GetCustomerData()).Currency === "COL"
            ? x.UnitPrice
            : parseFloat(
              Number(x.UnitPrice / this.DailyExRate).toString()
            ),
        UnitPriceCol: x.UnitPrice,
        UnitPriceDol: x.UnitPrice,
        U_SugPrice: 0,
        TaxCode: x.TaxCode,
        Quantity: x.Quantity,
        Active: true,
        Id: this.conta,
        LinTot: tot,
        TaxRate: x.TaxRate != 0.0 ? x.TaxRate : 0.0,
        DiscountPercent: x.DiscountPercent,
        WarehouseCode: x.WarehouseCode,
        WhsName: x.WhsName,
        Serie: "",
        SysNumber: 0,
        OnHand: x.OnHand,
        BaseEntry: x.BaseEntry,
        BaseType: x.BaseType,
        BaseLine: x.BaseLine == -1 ? null : x.BaseLine,
        LineNum: x.LineNum,
        U_NVT_ServicioMedico: x.U_NVT_ServicioMedico,
        TaxCode_BCK: x.TaxCode_BCK,
        TaxRate_BCK: x.TaxRate_BCK,
        ItemGroupCode: x.ItemGroupCode,
        LineStatus: x.LineStatus,
      } as IDocumentLine;

      this.itemsList.push(itemAux);
      this.LineTotalCalculate(this.itemsList.length - 1);
    });

  }
  private SetDocumentLines():void
  {
    const bpCardCode = this.businessPartnersSelect ? this.businessPartnersSelect.CardCode : 'null';
    const bpListNum = this.businessPartnersSelect ? this.businessPartnersSelect.ListNum : 'null';
    this.IndexMaxUpdate =  this.saleDocumentModel.DocumentLines.reduce((acc, i) => (i.LineNum > acc.LineNum ? i : acc)).LineNum || 0;
    this.IndexMinDocument =  this.saleDocumentModel.DocumentLines.reduce((acc, i) => (i.LineNum < acc.LineNum ? i : acc)).LineNum || 0;



    this.saleDocumentModel.DocumentLines.forEach((x) => {
      this.conta++;
      this.total += x.UnitPrice;
      const tot = x.UnitPrice * x.Quantity;


      let itemAux = {
        Item: `${x.ItemCode}`,
        ItemCode: `${x.ItemCode} - ${x.ItemCode}`,
        ItemName: `${x.ItemName}`,
        CodeName: `${x.ItemCode} - ${x.ItemName}`,
        UnitPrice:
          JSON.parse(this.storage.GetCustomerData()).Currency === "COL"
            ? x.UnitPrice
            : parseFloat(
              Number(x.UnitPrice / this.DailyExRate).toString()
            ),
        UnitPriceCol: x.UnitPrice,
        UnitPriceDol: x.UnitPrice,
        U_SugPrice: 0,
        TaxCode: x.TaxCode,
        Quantity: x.Quantity,
        Active: true,
        Id: this.conta,
        LinTot: tot,
        TaxRate: x.TaxRate != 0.0 ? x.TaxRate : 0.0,
        DiscountPercent: x.DiscountPercent,
        WarehouseCode: x.WarehouseCode,
        WhsName: x.WhsName,
        Serie: "",
        SysNumber: 0,
        OnHand: x.OnHand,
        BaseEntry: x.BaseEntry,
        BaseType: x.BaseType,
        BaseLine: x.BaseLine,
        LineNum: x.LineNum,
        U_NVT_ServicioMedico: x.U_NVT_ServicioMedico,
        TaxCode_BCK: x.TaxCode_BCK,
        TaxRate_BCK: x.TaxRate_BCK,
        ItemGroupCode: x.ItemGroupCode,
        InvntItem: x.InvntItem,
        LineStatus: x.LineStatus,
        U_TipoDescuento: x.U_TipoDescuento,
        U_DescuentoOtros: x.U_DescuentoOtros
      } as IDocumentLine;

      this.itemsList.push(itemAux);
      this.LineTotalCalculate(this.itemsList.length - 1);
    });

    // En modo edición, recalcular los impuestos de todas las líneas según la lista de precios actual
    // Esto corrige impuestos incorrectos que puedan estar guardados en el documento.
    // El descuento NO se recalcula aqui: se conserva el que trae el documento desde SAP (CCPCC-42).
    if (this.storage.GetUIAction() === SOAndSQActions.EditOrder && this.itemsList.length > 0) {
      this.setupRecalculate(false);
    }

  }

  /**
   * Retrieves a sales order based on the specified quotation document entry.
   * @param quotationDocEntry The document entry of the quotation associated with the sales order.
   */
  GetSaleOrder(quotationDocEntry: number) {
    this.blockUI.start("Procesando documento, espere por favor...");
    this.soAdnSQService.GetSaleOrder(quotationDocEntry).subscribe(
      (next) => {
        this.blockUI.stop();
        if (next.result) {
          this.conta = 0;
          this.total = 0;
          this.itemsList = [];

          let CustomerData: string = JSON.stringify({
            CardCode: next.Data.CardCode,
            Currency: next.Data.DocCurrency,
            SlpCode: next.Data.SalesPersonCode,
          });

          this.storageService.SaveCustomerData(CustomerData);

          this.DEFAULT_BUSINESS_PARTNER = next.Data.CardCode;

          this.saleDocumentModel = next.Data;

          let estadoOv = next.Data.U_EstadoOV;

          if (this.isOrderFromLink) {

            let msg: string = '';

            if (estadoOv == "02") {
              if (!this.isPermAutorizeSale)
                msg = "No cuenta con los permisos para realizar esta acción.";
            } else {
              msg = "El acceso a esta orden de venta no esta permitido.";
            }

            if (msg != '') {
              this.alertService.errorAlert(
                msg
              );
              this.router.navigate(["/home"]);
            }

            this.commonService.hasDocument.next(`Documento número ${this.saleDocumentModel.DocNum}`);
            this.storageService.SaveBreadCrum(`Documento número ${this.saleDocumentModel.DocNum}`);

          }

          if (estadoOv != null) {
            this.canAuthorize = estadoOv == "02" && this.isPermAutorizeSale;
            this.autForm.patchValue({ Estado: estadoOv });
          }

          this.baseLines = next.Data.DocumentLines;

          this.soForm.patchValue({
            PayTerms:
              this.saleDocumentModel.U_Facturacion === "Contado" ? "0" : "1",
            BillOverdue:
              this.saleDocumentModel.U_FacturaVencida === "SI" ? "0" : "1",
            SlpList: this.saleDocumentModel.SalesPersonCode,
            NumAtCard:
              this.saleDocumentModel.NumAtCard === "0"
                ? ""
                : this.saleDocumentModel.NumAtCard,
          });

          if (this.slpTypeaheadList.length > 0) {
            const SLP = this.slpTypeaheadList.find(x => x.SlpCode === this.saleDocumentModel.SalesPersonCode.toString());
            if (SLP) {
              this.soForm.patchValue({ SlpList: SLP });
            }
          }
          // Validar que businessPartnersSelect coincida con el CardCode del documento
          if (this.businessPartnersSelect!=null && this.businessPartnersSelect.CardCode === this.saleDocumentModel.CardCode) {
            const CUSTOMER = this.businessPartnersSelect;
            if (CUSTOMER) this.priceList = CUSTOMER.ListNum;
          }

          if (this.saleDocumentModel.U_NumIdentFE !== null) {
            this.feForm.patchValue({
              IdType: this.saleDocumentModel.U_TipoIdentificacion,
              Identification: this.saleDocumentModel.U_NumIdentFE,
              Email: this.saleDocumentModel.U_CorreoFE,
              ObservacionFE: this.saleDocumentModel.U_ObservacionFE,
            });

            this.isCashCustomer =
              this.saleDocumentModel.U_Facturacion === "Contado";

            if (this.isCashCustomer)
              (<HTMLButtonElement>(
                document.getElementById("triggerFECollapser")
              )).click();
          }

          this.soForm.patchValue({
            cardName: this.saleDocumentModel.CardName,
            PaymentMethod: this.saleDocumentModel.U_NVT_Medio_Pago,
            Comment: this.saleDocumentModel.Comments,
          });

          this.IndexMaxUpdate =  next.Data.DocumentLines.reduce((acc, i) => (i.LineNum > acc.LineNum ? i : acc)).LineNum || 0;
          this.IndexMinDocument =  next.Data.DocumentLines.reduce((acc, i) => (i.LineNum < acc.LineNum ? i : acc)).LineNum || 0;

          next.Data.DocumentLines.forEach((x) => {
            this.conta++;
            this.total += x.UnitPrice;
            const tot = x.UnitPrice * x.Quantity;
            let itemAux = {
              Item: `${x.ItemCode}`,
              ItemCode: `${x.ItemCode} - ${x.ItemCode}`,
              ItemName: `${x.ItemName}`,
              CodeName: `${x.ItemCode} - ${x.ItemName}`,
              UnitPrice:
                JSON.parse(this.storage.GetCustomerData()).Currency === "COL"
                  ? x.UnitPrice
                  : parseFloat(
                    Number(x.UnitPrice / this.DailyExRate).toString()
                  ),
              UnitPriceCol: x.UnitPrice,
              UnitPriceDol: x.UnitPrice,
              U_SugPrice: 0,
              TaxCode: x.TaxCode,
              Quantity: x.Quantity,
              Active: true,
              Id: this.conta,
              LinTot: tot,
              TaxRate: x.TaxRate != 0.0 ? x.TaxRate : 0.0,
              DiscountPercent: x.DiscountPercent,
              WarehouseCode: x.WarehouseCode,
              WhsName: x.WhsName,
              Serie: "",
              SysNumber: 0,
              OnHand: x.OnHand,
              BaseEntry: x.BaseEntry,
              BaseType: x.BaseType,
              BaseLine: x.BaseLine,
              LineNum: x.LineNum,
              U_NVT_ServicioMedico: x.U_NVT_ServicioMedico,
              U_TipoDescuento: x.U_TipoDescuento,
              U_DescuentoOtros: x.U_DescuentoOtros,
              TaxCode_BCK: x.TaxCode_BCK,
              TaxRate_BCK: x.TaxRate_BCK,
              ItemGroupCode: x.ItemGroupCode,
              InvntItem: x.InvntItem,
              LineStatus: x.LineStatus,
            } as IDocumentLine;

            this.itemsList.push(itemAux);
            this.LineTotalCalculate(this.itemsList.length - 1);
          });
          this.getTotals();
        } else {
          this.alertService.errorAlert(next.errorInfo.Message);
        }
      },
      (error) => {
        console.log(error);
        this.blockUI.stop();
        this.alertService.errorAlert(error);
      }
    );
  }

  queryFEData2() {
    let paymentTerm = this.PayTermsList.find(
      (x) => x.GroupNum === Number(this.soForm.controls.PayTerms.value)
    );

    this.hasIdentification = false;

    if (
      this.isCashCustomer &&
      this.feForm.controls.IdType.value &&
      this.feForm.controls.Identification.value
    ) {
      this.blockUI.start("Obteniendo datos FE...");
      this.bpService
        .GetCustomersCont(
          this.feForm.controls.IdType.value,
          this.feForm.controls.Identification.value
        )
        .subscribe(
          (data: any) => {
            this.blockUI.stop();
            this.hasIdentification = true;
            if (data.result) {
              if (this.isOnCreation)
                this.soForm.patchValue({ cardName: data.FEInfo.CardName });
              this.feForm.patchValue({ Email: data.FEInfo.Email });
            } else {
              // busca info del cliente en el padron
              this.blockUI.stop();
              this.blockUI.start("Obteniendo datos del padrón...");
              if (this.feForm.controls.Identification.value != "") {
                this.bpService
                  .GetCustomersContPadron(
                    this.feForm.controls.Identification.value
                  )
                  .subscribe(
                    (data) => {
                      this.blockUI.stop();
                      if (
                        data.tipoIdentificacion ==
                        this.feForm.controls.IdType.value
                      ) {
                        if (this.isOnCreation)
                          this.soForm.patchValue({
                            cardName: data.nombre,
                          });
                      } else {
                        this.alertService.errorInfoAlert(
                          `Error no se ha encontrado la información en el padron del número de identificación ingresado.`
                        );
                      }
                    },
                    (error: any) => {
                      this.blockUI.stop();
                      this.alertService.errorInfoAlert(
                        `Error Padrón: No se ha encontrado la información en el padron del número de identificación ingresado.`
                      );
                    }
                  );
              }
            }
          },
          (error: any) => {
            this.blockUI.stop();
            this.alertService.errorInfoAlert(
              `Error Obteniendo datos FE!!!, Error: ${error.error.Message}`
            );
          }
        );
    }
  }
  // Usa para invertir flecha que despliega la data de fe
  toggleArrow(): void {
    this.typeArrow = !this.typeArrow;
  }
  // Usada para validar el estado del formulario de fe
  triggerFECollapser(_isCashCustomer: boolean, _isToggledArrow: boolean): void {
    if (!_isCashCustomer) {
      this.createFEForm();
      if (_isToggledArrow)
        (<HTMLButtonElement>(
          document.getElementById("triggerFECollapser")
        )).click();
    }
  }

  recalculateTaxes(): void {
    const PAYMENT_METHOD = this.soForm.controls.PaymentMethod.value;
    this.itemsList.forEach((x, i) => {
      if (x.ItemGroupCode == ITEM_GROUP_NAME.SERV_VETERINARIA) {
        x.U_NVT_ServicioMedico = 1;
        if (PAYMENT_METHOD === "02") {
          // 02 - Tarjeta: aplicar IVA devuelto
          x.TaxCode = "44";
          x.TaxRate = 0;
        } else {
          x.TaxCode = x.TaxCode_BCK || x.TaxCode;
          x.TaxRate = x.TaxRate_BCK || x.TaxRate;
        }
      } else {
        x.U_NVT_ServicioMedico = 0;
        x.TaxCode = x.TaxCode_BCK || x.TaxCode;
        x.TaxRate = x.TaxRate_BCK || x.TaxRate;
      }
      this.LineTotalCalculate(i);
    });
    this.getTotals();
  }

  raiseCustomerBalance(): void {
    this.overdueBalances = [];
    this.blockUI.start(`Obteniendo balance`);
    this.bpService
      .GetCustomerBalance(this.soForm.controls.cardCode.value)
      .subscribe((next) => {
        this.blockUI.stop();
        if (next.result) {
          this.overdueBalances = next.OverdueBalance;
          (<HTMLButtonElement>(
            document.getElementById("triggerBalancePreview")
          )).click();
        }
      });
  }

  /**
   * Execute instructions after payment modal closed
   */
  closeAfterPayModal(): void {
    this.CleanFields();
  }

  redirectToQuotation() {
    this.router.navigate(["quotation"]);
  }

  redirectToSOandSQ() {
    this.router.navigate(["SOandSQ"]);
  }

  changeSlp($event: any): void {
    this.isSalesManSelected = true;
    let SLP = $event.item as ISaleMan;
    this.soForm.patchValue({ SlpList: SLP });
  }

  generateUniqueInvoiceId(): void {
    const USER_PREFIXID = JSON.parse(this.storage.getCurrentSession()).PrefixId;

    const DATE = new Date();

    const DAYS =
      DATE.getDate() < 10 ? "0" + DATE.getDate() : DATE.getDate().toString();
    const MONTS =
      DATE.getMonth() + 1 < 10
        ? "0" + (DATE.getMonth() + 1)
        : (DATE.getMonth() + 1).toString();
    const YEAR = DATE.getFullYear()
      .toString()
      .slice(
        DATE.getFullYear().toString().length - 2,
        DATE.getFullYear().toString().length
      );

    const HOURS =
      DATE.getHours() < 10 ? "0" + DATE.getHours() : DATE.getHours();
    const MINUTES =
      DATE.getMinutes() < 10 ? "0" + DATE.getMinutes() : DATE.getMinutes();
    const SECONDS =
      DATE.getSeconds() < 10 ? "0" + DATE.getSeconds() : DATE.getSeconds();

    this.uniqueInvCode = `${USER_PREFIXID + DAYS + MONTS + YEAR + HOURS + MINUTES + SECONDS
      }`;

  }

  overrideDiscount(): void {
    const DISCOUNT = this.soForm.value.Discount;

    if (DISCOUNT > 10) {
      this.soForm.patchValue({
        Discount: 0,
      });
      this.alertService.infoInfoAlert(
        `El descuento no puede ser mayor a ${this.maxDiscuont}% que es lo permitido para este usuario`
      );
      return;
    }

    const SIZE = this.itemsList.length;

    for (let c = 0; c < SIZE; c++) {
      if (this.itemsList[c].LinTot != 0) {
        this.itemsList[c].DiscountPercent = DISCOUNT;
      }
      this.LineTotalCalculate(c);
    }
  }

  SavePreviusAmount(_previusAmount: number, _index: number): void {
    if (!this.isPriceEditable || this.itemsList[_index].InvntItem === "Y") {
      this.alertService.infoInfoAlert(
        `No se puede editar el precio del item selecccionado`
      );
    }
    this.previusAmount = _previusAmount;
  }

  KeyUp(event: any, _index: number) {
    if (event.keyCode === 27) {
      this.itemsList[_index].UnitPrice = this.previusAmount;
      console.log(event.keyCode);
      this.LineTotalCalculate(_index);
      this.getTotals();
    }
  }

  SetValueUDF<V>(key: string, value: V): void {
    for (let i = 0; i < this.UdfsInDocument.length; i++) {
      if (this.UdfsInDocument[i].UDFName === key) {
        this.UdfsInDocument[i].Value = value;
        break;
      }
    }
  }

  GetDocumentUDFs(): UDFModel2[] {
    let UDFList: UDFModel2[] = [
      {
        Value: null,
        UDFName: "FacturaVencida",
        Description: "U_FacturaVencida",
        Type: 'String',
      },
      {
        Value: null,
        UDFName: "Facturacion",
        Description: "U_Facturacion",
        Type: 'String',
      },
      {
        Value: null,
        UDFName: "NVT_Medio_Pago",
        Description: "U_NVT_Medio_Pago",
        Type: 'String',
      },
      {
        Value: null,
        UDFName: "ObservacionFE",
        Description: "U_ObservacionFE",
        Type: 'String',
      },
      {
        Value: null,
        UDFName: "Almacen",
        Description: "U_Almacen",
        Type: 'String',
      },
      {
        Value: null,
        UDFName: "TipoDocE",
        Description: "U_TipoDocE",
        Type: 'String',
      },
      {
        Value: null,
        UDFName: "CorreoFE",
        Description: "U_CorreoFE",
        Type: 'String',
      },
      {
        Value: null,
        UDFName: "NumIdentFE",
        Description: "U_NumIdentFE",
        Type: 'String',
      },
      {
        Value: null,
        UDFName: "CLVS_POS_UniqueInvId",
        Description: "U_CLVS_POS_UniqueInvId",
        Type: 'String',
      },
      {
        Value: null,
        UDFName: "TipoIdentificacion",
        Description: "U_TipoIdentificacion",
        Type: 'String',
      },
      {
        Value: null,
        UDFName: "EstadoOV",
        Description: "U_EstadoOV",
        Type: 'String',
      },
      {
        Value: null,
        UDFName: "ObservacionAut",
        Description: "U_ObservacionAut",
        Type: 'String',
      },
      {
        Value: null,
        UDFName: "FechaAut",
        Description: "U_FechaAut",
        Type: 'DateTime',
      },
      {
        Value: null,
        UDFName: "CorreoAut",
        Description: "U_CorreoAut",
        Type: 'String',
      },
      {
        Value: null,
        UDFName: "ActividadReceptor",
        Description: "U_ActividadReceptor",
        Type: 'String',
      },
      {
        Value: null,
        UDFName: "CondicionVenta",
        Description: "U_CondicionVenta",
        Type: 'String',
      },
      {
        Value: null,
        UDFName: "CondicionVentaOtros",
        Description: "U_CondicionVentaOtros",
        Type: 'String',
      },
    ];

    return UDFList;
  }

  ChangePayterms($event: any): void {


    if (this.storage.GetDocEntry() > 0 && $event.target.value == "1") {
      this.blockUI.start("Consultado información del cliente.");
      this.bpService
        .CheckIfBPHaveAnyPending(this.saleDocumentModel.CardCode)
        .subscribe(
          (info) => {
            this.blockUI.stop();

            if (info.result) {
              if (info.Data.PayTermGroup != -1 && info.Data.RequiredAutorization) {
                this.alertService.infoAlert(
                  "Tiene documentos pendientes de pago, realizar gestión de cobro."
                );
                this.BpDocuemntPendingPay = info.Data.RequiredAutorization;
                if (
                  this.BpDocuemntPendingPay &&
                  this.soForm.controls.PayTerms.value === "1"
                  && this.storage.GetUIAction() !== SOAndSQActions.EditOrder
                ) {
                  this.onSubmitButtonPrefix = "Enviar órden a autorización";
                } else if (this.storage.GetUIAction() == SOAndSQActions.EditOrder) {
                  this.onSubmitButtonPrefix = "Actualizar órden de venta";
                } else {
                  this.onSubmitButtonPrefix = "Crear órden de venta";
                }

              }
            }
          },
          (err) => {
            this.blockUI.stop();
            this.alertService.errorAlert(
              "Ocurrio un error verificando los datos del cliente, causado por: " +
              err
            );
          }
        );
    } else
      if (
        this.BpDocuemntPendingPay &&
        this.soForm.controls.PayTerms.value === "1"
        && this.storage.GetDocEntry() < 0
      ) {
        this.onSubmitButtonPrefix = "Enviar órden a autorización";
      } else if (this.storage.GetUIAction() == SOAndSQActions.EditOrder) {
        this.onSubmitButtonPrefix = "Actualizar órden de venta";
      } else {
        this.onSubmitButtonPrefix = "Crear órden de venta";
      }

  }


  RisePBAutorizeContacts(): void {
    let modalOption: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'Modal-Xl',
      centered: true
    };

    let modalBPContacts = this.modalService.open(BPAutorizedContactsComponent, modalOption);
    modalBPContacts.componentInstance.cardCode = this.soForm.controls.cardCode.value;
  }


  /**
   * Opens a search modal.
   */
  RiseSearchModal():void {
    let modalOption: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'Modal-Xl',
      centered: true
    };

    let modalSearchItems = this.modalService.open(SearchModalComponent, modalOption);
    modalSearchItems.componentInstance.title = 'Busqueda de articulos';
    modalSearchItems.componentInstance.columns = [ 'ItemCode','ItemName', 'OnHand'];
    modalSearchItems.componentInstance.columnsName = ['Código','Nombre', 'Disponible'];
    modalSearchItems.componentInstance.SearchData =  this.SearchItem;
    modalSearchItems.componentInstance.selectRecord.subscribe((item) => {
      this.SelectRecordItem(item);
    });
  }

  /**
   * Searches for items based on the provided search parameters.
   * @param _data The search parameters.
   * @returns An observable that emits an array of ItemModelSearch objects.
   */
  SearchItem= (_data: ParamsSearch):Observable<ItemModelSearch[]> => {
    return this.itemService.GetItemsSearch(_data.SearchValue,_data.Page,_data.PageRecords,'so').
    pipe(map(result => result.ItemList));
  }

  /**
   * Selects a record item for further operations.
   * @param item The item to be selected.
   */
  SelectRecordItem(item: ItemModelSearch) {
    if(item!=null) {
      let mobileNavigatorObject: any = window.navigator;
      if (mobileNavigatorObject && mobileNavigatorObject.clipboard) {
        mobileNavigatorObject.clipboard
          .readText()
          .then((text) => {
            if (!isNaN(parseInt(text))) {
              if (Number(text) > this.maxWeightTo0) {
                mobileNavigatorObject.clipboard
                  .writeText("*")
                  .then((text) => {})
                  .catch((err) => {});
              }
            }

            if (this.correctSO) {
              this.ItemInfo.setValue("");
              this.alertService.infoInfoAlert(
                `Presione el boton limpiar para poder agregar productos a la orden`
              );
              return;
            }
            let cant = Number(this.Cant.value);

            let code = item.ItemCode;
            let searchitem = true;
            this.blockUI.start(
              "Obteniendo Información del Artículo, Espere Por Favor..."
            ); // Start blocking
            
            var index: number = this.itemsList.indexOf(this.itemsList.find((x) => x.Item == code));

            if (index != -1) {
              this.itemsList[index].Quantity += cant;
              this.itemsList[index].LinTot =
                this.itemsList[index].Quantity *
                this.itemsList[index].UnitPrice;
              searchitem = false;
              this.LineTotalCalculateExt(index);
              this.getTotals();
              this.blockUI.stop();
            }

            this.itemService
              .GetItemByItemCode(
                item.ItemCode,
                this.priceList,
                this.soForm.controls.cardCode.value
              ) // GETITEMINFO
              .subscribe(
                (data: any) => {
                  if (data.result) {
                    if (searchitem) {
                      this.conta++;
                      this.total += data.Item.UnitPrice;
                      const IS_VET_SERVICE = data.Item.ItemGroupCode == ITEM_GROUP_NAME.SERV_VETERINARIA;
                      const HAS_RETRIVED_TAX = IS_VET_SERVICE && this.soForm.controls.PaymentMethod.value === "02"; // 02 - Targeta
                      let tot =
                        this.soForm.get("currency").value === "COL"
                          ? data.Item.UnitPrice * cant
                          : cant *
                          parseFloat(
                            Number(
                              data.Item.UnitPrice / this.DailyExRate
                            ).toFixed(2)
                          );
                      let itemAux = {
                        Item: data.Item.ItemCode,
                        ItemCode: `${data.Item.ItemCode} - ${data.Item.ItemName}`,
                        ItemName: `${data.Item.ItemName}`,
                        CodeName: `${data.Item.ItemCode} - ${data.Item.ItemName}`,
                        UnitPrice:
                          this.soForm.get("currency").value === "COL"
                            ? data.Item.UnitPrice
                            : parseFloat(
                              Number(
                                data.Item.UnitPrice / this.DailyExRate
                              ).toFixed(2)
                            ),
                        UnitPriceCol: data.Item.UnitPrice,
                        UnitPriceDol: parseFloat(
                          Number(
                            data.Item.UnitPrice / this.DailyExRate
                          ).toFixed(2)
                        ),
                        U_SugPrice: 0,
                        TaxCode: HAS_RETRIVED_TAX ? "44" : data.Item.TaxCode, // 44 Iva devuelto codigo
                        TaxRate: HAS_RETRIVED_TAX ? 0 : data.Item.TaxRate, // 0 Iva devualto valor
                        TaxCode_BCK: data.Item.TaxCode,
                        TaxRate_BCK: data.Item.TaxRate,
                        ItemGroupCode: data.Item.ItemGroupCode,
                        Quantity: cant,
                        Active: true,
                        Id: this.conta,
                        LinTot: tot,
                        DiscountPercent: data.Item.Discount,
                        WarehouseCode: this.whCode,
                        WhsName: this.whName,
                        Serie: "",
                        SysNumber: 0,
                        OnHand: data.Item.OnHand,
                        U_NVT_ServicioMedico: IS_VET_SERVICE ? 1 : 0,
                        InvntItem: data.Item.InvntItem,
                        LineStatus: "O",
                        LineNum: -1
                      } as IDocumentLine;

                      this.itemsList.unshift(itemAux);
                      this.LineTotalCalculateExt(0);
                      this.getTotals();
                    }
                    this.Cant.setValue(1);
                    this.ItemInfo.setValue("");

                    if (data.Item.InvntItem === "Y" && data.Item.OnHand <= 0) {
                      this.itemsList[0].Quantity = 0;
                      this.itemsList[0].LinTot = 0;
                      searchitem = false;
                      this.LineTotalCalculate(0);
                      this.getTotals();
                    }
                  } else {
                    this.alertService.errorAlert(
                      `Error: no se pudo obtener la información del item solicitado: Código: ${data.errorInfo.Code}, Mensaje: ${data.errorInfo.Message}`
                    );
                  }
                  this.blockUI.stop(); // Stop blocking
                },
                (error: any) => {
                  this.blockUI.stop(); // Stop blocking
                  this.alertService.errorInfoAlert(
                    `Error al intentar conectar con el servidor, Error: ${error}`
                  );
                }
              );
          })
          .catch((err) => {});
      }
    }
  }


  /**
   * Opens a search modal.
   */
  RiseSearchModalBP():void {
    let modalOption: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'Modal-Xl',
      centered: true
    };

    let modalSearchItems = this.modalService.open(SearchModalComponent, modalOption);
    modalSearchItems.componentInstance.title = 'Busqueda de clientes';
    modalSearchItems.componentInstance.columns = [ 'CardCode','CardName'];
    modalSearchItems.componentInstance.columnsName = ['Código','Nombre'];
    modalSearchItems.componentInstance.SearchData =  this.SearchBP;
    modalSearchItems.componentInstance.selectRecord.subscribe((bp) => {
      this.SelectRecordBp(bp);
    });
  }

  /**
   * Searches for items based on the provided search parameters.
   * @param _data The search parameters.
   * @returns An observable that emits an array of ItemModelSearch objects.
   */
  SearchBP= (_data: ParamsSearch):Observable<IBusinessPartnerModel[]> => {
    return this.bpService.GetBussinesPartners(_data.SearchValue,_data.Page,_data.PageRecords).
    pipe(map(result => result.BusinessPartnerFilter));
  }

  /**
   * Selects a record item for further operations.
   * @param item The item to be selected.
   */
  SelectRecordBp(item: IBusinessPartnerModel) {
    if(item!=null) {
      let businessPartner: IBusinessPartnerModel = item;
      this.businessPartnersSelect = businessPartner;
      this.isCardNameTypedByUser = false;
      this.soForm.controls['cardCode'].setValue(businessPartner.CardCode);
      this.soForm.controls['cardName'].setValue(businessPartner.CardName);
      this.soForm.controls['ActividadReceptor'].setValue(businessPartner.U_ActividadReceptor);
      this.preselectTipoDocumento(businessPartner.U_ActividadReceptor);
      this.SetDataBPLines(businessPartner.CardCode);
      this.VerifyStatusMagHA(item);
    }
  }

  /**
   * Selects a record item for further operations.
   * @param item The item to be selected.
   */
  SelectRecordBpOnEdition(item: IBusinessPartnerModel) {
    if(item!=null) {
      let businessPartner: IBusinessPartnerModel = item;
      this.businessPartnersSelect = businessPartner;
      this.soForm.controls['cardCode'].setValue(businessPartner.CardCode);
      // El nombre del documento tiene prioridad sobre el del socio (ver SetDocument)
      this.soForm.controls['cardName'].setValue(
        (this.saleDocumentModel && this.saleDocumentModel.CardName)
          ? this.saleDocumentModel.CardName
          : businessPartner.CardName
      );
      // El tipo de documento electronico se deriva de la actividad economica del receptor:
      // el documento manda cuando la trae (editar/duplicar) y si no, los datos maestros del socio.
      const actividadReceptor = this.saleDocumentModel.U_ActividadReceptor || businessPartner.U_ActividadReceptor;
      this.soForm.controls['ActividadReceptor'].setValue(actividadReceptor);
      // En editar/duplicar el tipoDocumento ya lo establecio SetDocument() via patchValue.
      // En CopyToOrder ese patchValue NO corre y la proforma tampoco guarda U_TipoDocE, por lo que
      // el campo se quedaba en su valor inicial ("TE") aunque el socio aplicara para FE: hay que
      // preseleccionarlo igual que en una orden creada desde cero.
      if (this.storage.GetUIAction() === SOAndSQActions.CopyToOrder) {
        this.preselectTipoDocumento(actividadReceptor);
      }
      this.SetDataBPLines(businessPartner.CardCode);
    }
  }

  /**
   * Sets the default business partner.
   */
  SetDefaultBP(): void {
    this.GetCurrencyType();
    this.GetPayTerms();

    const MOBJECT = this.saleDocumentModel;
    if (MOBJECT) {
      this.bpService.GetBussinesPartnerByCardCode(MOBJECT.CardCode)
        .pipe()
        .subscribe(
          (bp) => {
            if(bp!=null){
              this.soForm.controls['ActividadReceptor'].setValue(bp.BusinessPartnerModel.U_ActividadReceptor);
              this.preselectTipoDocumento(bp.BusinessPartnerModel.U_ActividadReceptor);
              this.priceList = bp.BusinessPartnerModel.ListNum;
              this.isCashCustomer = bp.BusinessPartnerModel.QryGroup1 === "Y";
            }
          },
          err => {console.log(err);}
        )
    }
  }

  /**
   * Validates guarantee credit for a specific business partner.
   * @param item The business partner model to validate guarantee credit for.
   */
  ValidatedGuaranteeCredit(item: IBusinessPartnerModel){
    if(item!=null){
      if(item.U_POS_CreditGuaranteeDueDate!=null){
        let specificDate: Date = new Date(item.U_POS_CreditGuaranteeDueDate); // Aquí puedes colocar tu fecha específica
        let currentDate: Date = new Date();
        let daysDiff: number;
        const diffTime = specificDate.getTime() - currentDate.getTime();
        daysDiff = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        const formattedDate = this.formatDateToDDMMYYYY(specificDate);
        if(daysDiff<0){
          this.alertService.AlertErrorMessageWithReturn(`La garantía del ${item.CardName} ya expiró, debe de pasar al departamento de cuentas por cobrar.`, 'info').then(value => {
            this.CheckIfBPHaveAnyPending(item.CardCode);
          });
        }
        if(daysDiff>=0 &&daysDiff<=60){
          this.alertService.AlertErrorMessageWithReturn(`La garantía del ${item.CardName} vence el ${formattedDate}, debe de pasar al departamento de cuentas por cobrar.`, 'info').then(value => {
            this.CheckIfBPHaveAnyPending(item.CardCode);
          })
        }
      }else{
        this.CheckIfBPHaveAnyPending(item.CardCode);
      }
    }
  }

  VerifyStatusMagHA(item: IBusinessPartnerModel): void {
    if(item!=null){

      if(item.U_NVT_InscMAG=='1' && this.companiesList[0].ValidatedInscription) {
        this.blockUI.start(
          "Obteniendo validacion Hacienda y MAG, Espere Por Favor..."
        ); // Start blocking
        this.bpService
          .ValidateBussinesPartnerByCardCode(item.CardCode)
          .subscribe(
            (data: any) => {
              this.blockUI.stop(); 

              if (data.HaciendaConnectionError === true) {
                this.showHaciendaErrorModal(item, data.Message);
              } else if (data.Result) {
                this.alertService.AlertErrorMessageWithReturn(data.Message, 'info').then(value => {
                  this.ValidatedGuaranteeCredit(item);
                });
              } else {
                // Error de validación (cliente no válido)
                const errorCode = data.errorInfo ? data.errorInfo.Code : 'N/A';
                const errorMessage = data.errorInfo ? data.errorInfo.Message : 'Error desconocido';
                this.alertService.AlertErrorMessageWithReturn(
                  `Error: no se pudo obtener la información del Cliente solicitado:  Código: ${errorCode}, Mensaje: ${errorMessage}`, 'error'
                ).then(value => {
                  this.ValidatedGuaranteeCredit(item);
                });
              }
            },
            (error: any) => {
              this.blockUI.stop(); 
              this.alertService.AlertErrorMessageWithReturn(
                `Error al intentar conectar con el servidor, Error: ${error}`, 'error'
              ).then(value => {
                this.ValidatedGuaranteeCredit(item);
              });
            });
      }else{
        this.ValidatedGuaranteeCredit(item);
      }
    }
  }

  /**
   * Shows a modal dialog when there's a connection error with Hacienda API.
   * Allows user to choose between continuing without validation or canceling the operation.
   * @param item - The business partner being validated
   * @param errorMessage - The error message from the API
   */
  async showHaciendaErrorModal(item: IBusinessPartnerModel, errorMessage: string): Promise<void> {
    const result = await this.alertService.ConfirmationAlert(
      'Hacienda con problemas',
      `No se pudo conectar con el servicio de Hacienda.\n\n` +
      `Detalle: ${errorMessage}\n\n` +
      `¿Desea continuar sin validar en Hacienda o cancelar la operación?`,
      'Aplicar flujo sin validar'
    );

    if (result) {
      this.alertService.infoInfoAlert(
        'Continuando sin validar en Hacienda. Los datos del cliente no fueron modificados.'
      );

      this.ValidatedGuaranteeCredit(item);
    } else {
      this.alertService.errorInfoAlert('Operación cancelada por el usuario');

      this.ClearCustomerData();
    }
  }

  /**
   * Clears the customer data from the sales order form.
   * Called when user cancels the operation due to Hacienda connection error.
   */
  ClearCustomerData(): void {
    // Resetear campos del formulario relacionados con el cliente
    this.businessPartnersSelect = null;
    this.isCardNameTypedByUser = false;
    this.soForm.patchValue({
      cardCode: '',
      cardName: '',
      ActividadReceptor: ''
    });

    // Reset totales
    this.total = 0;
    this.totalWithoutTax = 0;
  }

  /**
   * Formats a given date into a string with the format "DD/MM/YYYY".
   * @param date - The date object to be formatted.
   * @returns A string representing the formatted date in "DD/MM/YYYY" format.
   */
  formatDateToDDMMYYYY(date: Date): string {
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  /**
   * Fetches the typeahead configuration settings from the server.
   * If the response is successful, assigns the settings to the local `typeaheadSettings` property.
   * If an error occurs during the request, an error alert is shown to the user.
   */
  GetTypeaheadSettings(){
    this.companyService.GetTypeaheadSettings().subscribe(typeaheadResponse => {
      if(typeaheadResponse.result) {
        this.typeaheadSettings = typeaheadResponse.TypeaheadSettings;
      }
    }, error => {
      this.alertService.errorInfoAlert(`Error al intentar conectar con el servidor, Error: ${error}`);
    })
  }
}
